// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T18:12:24.193Z
// Property: Admirals Cove (ID: 6767906449167165)
// Collections: 34 amenities, 3 floorplans (live), 16 photos, 75 POIs, 5 reviews, 2 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167165",
  "property_external_id": "1101824",
  "property_zillow_url": "https://www.zillow.com/apartments/anchorage-ak/admirals-cove/5XqYZY/",
  "property_apartments_url": "https://www.apartments.com/admirals-cove-anchorage-ak/qhkhr9y/",
  "property_google_business_url": "https://www.google.com/maps/place/Admirals+Cove/data=!4m2!3m1!1s0x0:0xf9b531404e336107?sa=X&ved=2ahUKEwi0sKav44OTAxX2GFkFHekxJQYQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47571307064",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "admirals-cove",
  "property_name": "Admirals Cove",
  "property_website_url": "https://alaska.weidner.com/apartments/ak/anchorage/admirals-cove-0/",
  "property_domain": "https://www.admiralscoveapartments.com",
  "property_address": "6029 DeBarr Rd",
  "property_full_address": "6029 DeBarr Rd, Anchorage, AK 99504",
  "property_address_1": "6029 DeBarr Rd",
  "property_address_2": null,
  "property_address_city": "Anchorage",
  "property_address_state": "AK",
  "property_address_zip_full": null,
  "property_address_zip": "99504",
  "property_address_country": "US",
  "property_address_county": "Anchorage Municipality",
  "property_neighborhood_address": "Northeast Anchorage",
  "property_address_latitude": "61.21031739999999",
  "property_address_longitude": "-149.7683251",
  "property_email": "admiralscove@weidner.com",
  "property_phone": "(907) 308-2944",
  "property_call_tracking_phone": "907-308-2944",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Admirals Cove in Anchorage, AK, where comfort meets modern living. Our spacious two-bedroom floor plans boast gourmet kitchens with granite countertops, cozy fireplaces, and serene patios. Enjoy an on-site dog park, a top-tier fitness center, and attentive management—everything you need to feel right at home. Your ideal apartment awaits!",
  "property_long_description": "Welcome to Admirals Cove, where modern living meets the stunning beauty of Anchorage, AK! Our two-bedroom apartments are thoughtfully designed to offer you the ultimate comfort and convenience. Each residence features spacious floor plans with high-end finishes, including granite countertops, stainless steel appliances, and energy-efficient fixtures that make your home both stylish and eco-friendly.\n\nEnjoy the luxury of an in-home stackable washer and dryer, and relax in cozy evenings by the fireplace. With large and walk-in closets, vaulted ceilings, and a dedicated dining area, you’ll have all the space you need to truly make it your own. Step outside to your private patio or balcony and take in the views that surround you.\n\nAt Admirals Cove, we believe that lifestyle is key. Our community offers a range of premium amenities designed to enhance your living experience. Stay active in our state-of-the-art fitness center equipped with the latest cardio machines or take your furry friend to our on-site dog park for some outdoor fun. With on-site management and maintenance, you can enjoy peace of mind knowing that help is just a call away.\n\nDon’t miss out on your chance to call Admirals Cove home! Find your new apartment today by browsing our availability or schedule a tour to visit our vibrant community. Experience the perfect blend of comfort, convenience, and scenic beauty in Anchorage.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-7408-71fe-b51b-fe43016990a2.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and a breakfast bar with stools.",
    "public_id": "01a11a1d-7408-71fe-b51b-fe43016990a2",
    "storage_key": "property/6767906449167165/01a11a1d-7408-71fe-b51b-fe43016990a2.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "150",
  "property_year_built": "2003",
  "property_year_renovated": null,
  "property_walk_score": "67",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.66666666666667",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $1,000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaska-weidner.securecafe.com/onlineleasing/admirals-cove-0/floorplans.aspx",
  "property_resident_portal_url": "https://alaska-weidner.securecafenet.com/residentservices/admirals-cove-0/userlogin",
  "property_apply_now_url": "https://alaska-weidner.securecafe.com/onlineleasing/admirals-cove-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddc-8087-71b7-a838-68b5bef328c6.webp",
  "property_primary_logo_media": {
    "alt_text": "Admirals Cove Apartment Homes logo",
    "public_id": "01a10ddc-8087-71b7-a838-68b5bef328c6",
    "storage_key": "property/6767906449167165/01a10ddc-8087-71b7-a838-68b5bef328c6.webp",
    "width": 194,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddc-b35b-750d-ac69-e86aa22d3e56.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Love notes logo",
    "public_id": "01a10ddc-b35b-750d-ac69-e86aa22d3e56",
    "storage_key": "property/6767906449167165/01a10ddc-b35b-750d-ac69-e86aa22d3e56.webp",
    "width": 194,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddc-a8e2-72d8-a14b-496ceba13144.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Love Notes logo",
    "public_id": "01a10ddc-a8e2-72d8-a14b-496ceba13144",
    "storage_key": "property/6767906449167165/01a10ddc-a8e2-72d8-a14b-496ceba13144.webp",
    "width": 194,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#68c0b0",
  "property_secondary_color": "#1b3a4b",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#2a8c7d",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1100",
  "property_sqft_min": "1000",
  "property_sqft_max": "1100",
  "property_price_range": "1515 - 3400",
  "property_price_min": "1515",
  "property_price_max": "3400",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/AdmiralsCoveApartments",
  "property_instagram_url": "https://www.instagram.com/admirals_cove_weidner/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJiWQyho2WyFYRB2EzTkAxtfk",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Admirals Cove",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Home",
  "property_home_amenities_blurb": "Welcome to Admirals Cove in Anchorage, AK, where modern living meets comfort. Choose from our spacious two-bedroom layouts featuring gourmet granite countertops, energy-efficient stainless steel appliances, and cozy fireplaces. Enjoy our community's on-site dog park, state-of-the-art fitness center, and stunning views, all designed to enhance your lifestyle.",
  "property_home_floorplans_blurb": "At Admirals Cove in Anchorage, AK, experience luxury living with thoughtfully designed floor plans that cater to your lifestyle. Each apartment home combines modern comfort and stunning views, creating a serene retreat. Browse our available options today and let your ideal living space come to life.",
  "property_home_gallery_blurb": "At Admirals Cove in Anchorage, AK, your two-bedroom sanctuary awaits. Enjoy the perfect blend of comfort and convenience with spacious floor plans, stunning views, and amenities like a state-of-the-art fitness center and an on-site dog park. Picture yourself unwinding by the fireplace or savoring panoramic vistas from your private patio.",
  "property_home_neighborhood_blurb": "At Admirals Cove, life in Anchorage blends comfort with adventure. Embrace the vibrant community with cultural gems like the Anchorage Museum, the Alaska Zoo, and lush parks like Valley of the Moon. Dive into the local scene, from the University of Alaska to fitness centers, ensuring every day is uniquely yours.",
  "property_home_reviews_blurb": "Welcome to Admirals Cove in Anchorage, AK, where residents rave about the \"beautiful views and friendly atmosphere.\" Experience a community where comfort meets charm. Want to know more? See what our residents have to say about living at our vibrant apartment community and find your perfect home today!",
  "property_neighborhood_blurb": "Nestled in the heart of Anchorage, Admirals Cove offers two-bedroom floor plans surrounded by vibrant culture and nature. Unwind at the Alaska Botanical Garden, explore the Anchorage Museum, or soak in the beauty of nearby parks. Experience the perfect blend of urban living and outdoor adventures right at your doorstep.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Admirals Cove in Anchorage, AK, our two-bedroom apartments blend modern elegance with comfort. Enjoy spacious layouts featuring granite countertops, stainless steel appliances, and vaulted ceilings. Stay active in our state-of-the-art fitness center or unwind at the on-site dog park. Experience community living redefined—your ideal home awaits!",
  "property_applynow_blurb": "At Admirals Cove in Anchorage, AK, our spacious two-bedroom apartments offer a vibrant blend of modern living and comfort. Enjoy resort-style amenities like an on-site dog park, state-of-the-art fitness center, and elegant granite countertops. With convenient in-home features and stunning views, your new sanctuary awaits. Lease online today!",
  "property_contactus_blurb": "At Admirals Cove in Anchorage, AK, our spacious two-bedroom floor plans redefine comfort and style. Enjoy breathtaking views and thoughtful layouts designed for modern living. Elevate your lifestyle in a community that truly feels like home. Have questions? Contact our leasing team today and let us assist you!",
  "property_faqs_blurb": "At Admirals Cove in Anchorage, AK, our spacious two-bedroom floor plans are designed for comfortable living. If you have questions about our vibrant community, our FAQs page is here to guide you. Unearth all the insights you need and envision your new home today!",
  "property_floorplans_blurb": "At Admirals Cove in Anchorage, AK, our thoughtfully designed two-bedroom floor plans offer the ideal blend of comfort and style. With ample space and inviting interiors, you're one step closer to finding your perfect home. Browse our available apartment homes and embrace a lifestyle tailored just for you.",
  "property_gallery_blurb": "At Admirals Cove in Anchorage, AK, your dream lifestyle awaits in our spacious two-bedroom apartments. Picture pristine views, modern amenities like a state-of-the-art fitness center, and a cozy fireplace to unwind. With large closets, granite countertops, and an on-site dog park, every detail is designed for comfort and convenience.",
  "property_interactivemap_blurb": "At Admirals Cove in Anchorage, AK, your ideal two-bedroom sanctuary awaits. Revel in luxury with granite countertops, stainless steel appliances, and a cozy fireplace. Enjoy unique amenities, including a dog park and a state-of-the-art fitness center. Use our interactive community map today to find your perfect home!",
  "property_pets_blurb": "At Admirals Cove in Anchorage, your furry friends are embraced with open arms! With no weight limit for cats and dogs, our pet-friendly community ensures a welcoming home for your beloved companions. Unwind together in spacious living areas designed for comfort and connection in Alaska’s serene landscapes.",
  "property_referafriend_blurb": "At Admirals Cove in beautiful Anchorage, AK, our spacious two-bedroom floor plans are designed for comfort and style. Share your living experience with friends and create lasting memories together. Great friends make great neighbors—invite someone special to join our vibrant community today and enjoy all that Admirals Cove has to offer!",
  "property_residentaccess_blurb": "At Admirals Cove in Anchorage, AK, our spacious two-bedroom apartments offer a perfect blend of comfort and style. Enjoy the ease of managing your home with our resident portal—access it now to pay rent, schedule maintenance, and more for a hassle-free living experience!",
  "property_reviews_blurb": "At Admirals Cove in Anchorage, AK, our residents rave, “The community vibe is unmatched; it truly feels like home!” Join the thriving neighborhood and experience our welcoming atmosphere firsthand. Don’t just take our word for it—see what our residents have to say about living at our community!",
  "property_created_at": "1771535288927",
  "property_scheduletour_blurb": "At Admirals Cove in Anchorage, AK, our spacious two-bedroom floor plans offer the perfect blend of comfort and style. Immerse yourself in vibrant living while enjoying breathtaking views. Curious about the community experience? Read our residents’ testimonials and schedule your tour today for a firsthand glimpse of your potential new home!",
  "property_thankyou_blurb": "Thank you for your interest in Admirals Cove, where comfort meets stunning views in Anchorage, AK. Our spacious two-bedroom floor plans are designed for your lifestyle. Expect to hear from our dedicated team soon; we’re excited to help you find your perfect home. Your new beginning awaits!",
  "property_virtualtours_blurb": "Step into Admirals Cove, where spacious two-bedroom apartments seamlessly blend comfort and style in stunning Anchorage, AK. Experience breathtaking views and modern living by taking a virtual tour of our community. Your perfect home awaits—journey through our inviting spaces and envision your new lifestyle today!",
  "property_copyright": "2026 All Rights Reserved. Admirals Cove",
  "property_seo_title_home": "Admirals Cove |  Apartments in Anchorage, AK",
  "property_seo_description_home": "Experience life at Admirals Cove in Anchorage, AK! Cozy two-bedroom plans, on-site dog park, fitness center, and modern amenities await. Your new home is here!",
  "property_seo_title_floorplans": "Floor Plans | Anchorage, AK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal fit at Admirals Cove in Anchorage, AK! Browse our spacious two-bedroom floor plans perfect for comfort and style. Your new home awaits!",
  "property_seo_title_amenities": "Amenities | Anchorage, AK Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort at Admirals Cove, Anchorage, AK. Enjoy spacious two-bedroom layouts with amenities like a dog park and fitness center!",
  "property_seo_title_gallery": "Gallery | Apartments in Anchorage, AK",
  "property_seo_description_gallery": "Experience life at Admirals Cove in Anchorage, AK. Browse our stunning photo gallery to envision your new home with modern amenities and breathtaking views!",
  "property_seo_title_virtualtours": "Virtual Tours | Admirals Cove Apartments",
  "property_seo_description_virtualtours": "Experience life at Admirals Cove in Anchorage, AK! Immerse yourself in our two-bedroom apartments. Take a virtual tour today and envision your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Admirals Cove Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Admirals Cove in Anchorage, AK. Enjoy spacious two-bedroom layouts, modern amenities, and a stunning on-site dog park.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Anchorage, AK",
  "property_seo_description_neighborhood": "Uncover the best of Anchorage at Admirals Cove! Dive into local favorites and discover nearby gems just steps from your two-bedroom home. Explore now!",
  "property_seo_title_contact": "Contact Us | Admirals Cove",
  "property_seo_description_contact": "Connect with Admirals Cove in Anchorage, AK! Inquire about our spacious two-bedroom floor plans and let our leasing team assist you with your questions today!",
  "property_seo_title_faqs": "FAQs | Apartments in Anchorage, AK",
  "property_seo_description_faqs": "Explore Admirals Cove in Anchorage for answers, amenities, and a welcoming community that will make you feel right at home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Anchorage, AK",
  "property_seo_description_reviews": "Find out why residents love calling Admirals Cove home! Enjoy luxury amenities, stunning views, and a pet-friendly atmosphere in beautiful Anchorage, AK.",
  "property_seo_title_applynow": "Apply Now | Apartments in Anchorage, AK",
  "property_seo_description_applynow": "Find your perfect haven at Admirals Cove in Anchorage! Enjoy spacious two-bedroom layouts, upscale amenities, and a scenic dog park. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Admirals Cove",
  "property_seo_description_residentaccess": "Access your Admirals Cove resident portal in Anchorage, AK! Easily pay rent, schedule maintenance, and stay connected to your community all in one place.",
  "property_seo_title_referafriend": "Refer A Friend | Admirals Cove",
  "property_seo_description_referafriend": "Share the joy of living at Admirals Cove! Refer a friend and help them find the perfect Anchorage home. Great friends make great neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | Admirals Cove",
  "property_seo_description_scheduletour": "Experience the charm of Admirals Cove in Anchorage, AK! Ready to find your dream home? Schedule a tour today and envision your ideal lifestyle with us!",
  "property_seo_title_privacy": "Privacy Policy | Admirals Cove",
  "property_seo_description_privacy": "Your privacy matters at Admirals Cove. Learn how we protect your information in our clear and concise privacy policy. Click to read more today!",
  "property_seo_title_accessibility": "Website Accessibility | Admirals Cove",
  "property_seo_description_accessibility": "Admirals Cove in Anchorage champions accessibility for all. Experience inclusive living with features designed for every resident. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | Admirals Cove",
  "property_seo_description_sitemap": "Navigate your future home at Admirals Cove in Anchorage, AK! Check out our sitemap for easy access to amenities, floor plans, and community highlights.",
  "property_seo_title_thankyou": "Thank You | Admirals Cove",
  "property_seo_description_thankyou": "Thank you for reaching out! Your inquiry is valued at Admirals Cove, where stunning views and vibrant community living await. Stay tuned for our response!",
  "property_seo_title_pets": "Pet Policy | Apartments in Anchorage, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793047166404",
  "amenities": [
    {
      "id": "ec_eb8606bbe402f116548bea51",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452407",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de75f37e64c800d289561acd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87459950",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ec0b029704c2ce75afa9520",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452410",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_451a548510fa33cee5951d3f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452408",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d9a45-e6ac-755a-95de-8e267954ffcd.webp",
      "amenity_image_media": {
        "alt_text": "Elevator lobby with seating area and artwork",
        "public_id": "019d9a45-e6ac-755a-95de-8e267954ffcd",
        "storage_key": "property/6767906449167165/019d9a45-e6ac-755a-95de-8e267954ffcd.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "Admirals Cove Apartments - Elevator",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2398d5a37de5abf32afe0ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452409",
      "title": "Fitness Center",
      "amount": "false",
      "description": "24 hours (3 different gyms)",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-4095-70e7-99a4-d05ba1a7133b.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and exercise bikes.",
        "public_id": "019d021a-4095-70e7-99a4-d05ba1a7133b",
        "storage_key": "property/6767906449167165/019d021a-4095-70e7-99a4-d05ba1a7133b.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Admirals Cove Apartments - Fitness Center",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b051ec8a36f2f75c7efcecf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452411",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_903a147769275ebf300c6f41",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452412",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9272a73f2391c0528af1854a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452414",
      "title": "Tanning Bed",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b4545fc034054cbdd84023d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452419",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_29b42d0807b553d638fc8c98",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452416",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c62d710130c53afddb81f87a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452417",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5dc11970c8b26e67729ab48d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452418",
      "title": "Online Payments & Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f2999f5d3682cddad6bed14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452420",
      "title": "Planned Social Activities/ Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_771061438cb86241de563d00",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "122641552",
      "title": "Bilingual Leasing Team Members",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3362433682408f2714da263",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "124799711",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_029af5120c66e96badd9ccef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452453",
      "title": "In-Home Stackable Washer & Dryer",
      "amount": "false",
      "description": "All homes come with a washer and dryer but are able to be removed and replaced with your own",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11f4c-0a50-7559-a142-543a5003e664.webp",
      "amenity_image_media": {
        "alt_text": "Stacked washer and dryer in a closet",
        "public_id": "01a11f4c-0a50-7559-a142-543a5003e664",
        "storage_key": "property/6767906449167165/01a11f4c-0a50-7559-a142-543a5003e664.webp",
        "width": 1920,
        "height": 1080
      },
      "amenity_image_alt_text": "Admirals Cove Apartments - Washer Dryer",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_346e7a33024f9b16fd987dda",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452432",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ec117ce2f7d0a10e47c9eec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452433",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bcb250d982f2f4a34c5da4ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452435",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c82ed1a7d6d1a257b941329d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452436",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11f4c-0d40-7118-983e-87e78536c61f.webp",
      "amenity_image_media": {
        "alt_text": "Living room and kitchen area with fireplace, sofa, chairs, and breakfast bar.",
        "public_id": "01a11f4c-0d40-7118-983e-87e78536c61f",
        "storage_key": "property/6767906449167165/01a11f4c-0d40-7118-983e-87e78536c61f.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "Admirals Cove Apartments - Living Room,Admirals Cove Apartments - Living Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f311b32f9d495c044cc0b14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452434",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36ea74b319f5568cc22048e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452438",
      "title": "Instant Hot Water",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04abf49af92fc215ad9a64af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452439",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d9a45-e2f9-7709-a60d-6b4a14a322c8.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom vanity with granite countertop and walk-in closet",
        "public_id": "019d9a45-e2f9-7709-a60d-6b4a14a322c8",
        "storage_key": "property/6767906449167165/019d9a45-e2f9-7709-a60d-6b4a14a322c8.webp",
        "width": 1920,
        "height": 1080
      },
      "amenity_image_alt_text": "Admirals Cove Apartments - Bathroom",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c344a234842a50cabbc7f27",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452440",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_042e621adaf1bb0eaf913a21",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452441",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de55c358c9c1b6148831ba83",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452452",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4244fcd4dcb5b6f80191ef35",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452451",
      "title": "Vaulted Ceiling",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_320e84233d72e8d4e4b5e3b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452442",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-6a3d-7157-976b-df7f638091ad.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, granite countertop peninsula, and bar stools.",
        "public_id": "019d021a-6a3d-7157-976b-df7f638091ad",
        "storage_key": "property/6767906449167165/019d021a-6a3d-7157-976b-df7f638091ad.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "Admirals Cove Apartments - Dining Area",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_790c8f2e6ea262b10bde1840",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452443",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11f4c-0ae2-708a-bab4-e5b708455b40.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and shower.",
        "public_id": "01a11f4c-0ae2-708a-bab4-e5b708455b40",
        "storage_key": "property/6767906449167165/01a11f4c-0ae2-708a-bab4-e5b708455b40.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "Admirals Cove Apartments - Bathroom",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b74bb27ccb789faa9acf9a6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452444",
      "title": "Instant Hot Water Dispenser",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_105751f9d574b9c2d4eeeb43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452445",
      "title": "Intercom/ Call Box",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0de40f6c1b09fd5d0dc917c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452446",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5216cdf30b92563d58b96b0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452455",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72731139d0a1ec91eff0324b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "external_id": "87452456",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-6a56-72b5-b7a1-55559f7faf24.webp",
      "amenity_image_media": {
        "alt_text": "Empty walk-in closet with wire shelving",
        "public_id": "019d021a-6a56-72b5-b7a1-55559f7faf24",
        "storage_key": "property/6767906449167165/019d021a-6a56-72b5-b7a1-55559f7faf24.webp",
        "width": 1920,
        "height": 1080
      },
      "amenity_image_alt_text": "Admirals Cove Apartments - Closet",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_7ee52e50e749593d3bcaca6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-7408-71fe-b51b-fe43016990a2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and a breakfast bar with stools.",
        "public_id": "01a11a1d-7408-71fe-b51b-fe43016990a2",
        "storage_key": "property/6767906449167165/01a11a1d-7408-71fe-b51b-fe43016990a2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this spacious kitchen, featuring ample cabinet storage, granite countertops, and a convenient breakfast bar.",
      "link": "false",
      "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and a breakfast bar with stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites (1).jpg"
    },
    {
      "id": "ec_4b4bd2bbffe7007a686a1ebd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-1d03-70cf-a571-3cbef1e9d1a2.webp",
      "image_media": {
        "alt_text": "ORA Power Rankings Best in State 2020 J Turner Research logo",
        "public_id": "019d021a-1d03-70cf-a571-3cbef1e9d1a2",
        "storage_key": "property/6767906449167165/019d021a-1d03-70cf-a571-3cbef1e9d1a2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Logo",
      "description": "This award signifies top-ranking performance in the state, as recognized by J Turner Research's ORA Power Rankings in 2020.",
      "link": "false",
      "alt_text": "ORA Power Rankings Best in State 2020 J Turner Research logo",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/admirals cove j turner graphic.jpg"
    },
    {
      "id": "ec_0fa6a523b1deb320986cf24a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-8d06-73cc-8f59-63e497011ea9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and a white stove.",
        "public_id": "01a11a1d-8d06-73cc-8f59-63e497011ea9",
        "storage_key": "property/6767906449167165/01a11a1d-8d06-73cc-8f59-63e497011ea9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this inviting kitchen, featuring sleek light wood cabinets, beautiful granite countertops, and modern appliances. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and a white stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites  (37).jpg"
    },
    {
      "id": "ec_02f1da8de925d217f3cb6609",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-9f12-779a-856e-7c291b2f74c2.webp",
      "image_media": {
        "alt_text": "Living room with a brown sofa, patterned armchair, fireplace, TV, and coffee table.",
        "public_id": "01a11a1d-9f12-779a-856e-7c291b2f74c2",
        "storage_key": "property/6767906449167165/01a11a1d-9f12-779a-856e-7c291b2f74c2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush brown sofa, a decorative armchair, a fireplace with a television above, and a coffee table. Large windows and a sliding door provide natural light and access to an outdoor space.",
      "link": "false",
      "alt_text": "Living room with a brown sofa, patterned armchair, fireplace, TV, and coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites (3).jpg"
    },
    {
      "id": "ec_f8574bd358d68b5ba3c82446",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-a78e-74a8-adb6-095ab413076b.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and balcony view",
        "public_id": "01a11a1d-a78e-74a8-adb6-095ab413076b",
        "storage_key": "property/6767906449167165/01a11a1d-a78e-74a8-adb6-095ab413076b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable seating, and a glass-top dining table with a view of the balcony and greenery.",
      "link": "false",
      "alt_text": "Living room with fireplace and balcony view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites (9).jpg"
    },
    {
      "id": "ec_a2237029f514cc492c84c6b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-8b92-70ed-a49f-9fc63d0556c2.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and open kitchen.",
        "public_id": "01a11a1d-8b92-70ed-a49f-9fc63d0556c2",
        "storage_key": "property/6767906449167165/01a11a1d-8b92-70ed-a49f-9fc63d0556c2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable seating, and a view into the open kitchen with bar seating.",
      "link": "false",
      "alt_text": "Living room with fireplace and open kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites  (43).jpg"
    },
    {
      "id": "ec_134fac65bb31311d93e55cf1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-4095-70e7-99a4-d05ba1a7133b.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and exercise bikes.",
        "public_id": "019d021a-4095-70e7-99a4-d05ba1a7133b",
        "storage_key": "property/6767906449167165/019d021a-4095-70e7-99a4-d05ba1a7133b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and free weights for a great workout.",
      "link": "false",
      "alt_text": "Gym with treadmills, ellipticals, and exercise bikes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites  (35).jpg"
    },
    {
      "id": "ec_40d9234a0a2aaf67cd32b49e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-8e88-75f1-a5fd-6ccab6df3992.webp",
      "image_media": {
        "alt_text": "Kitchen counter with place settings and a view of the living room with a fireplace.",
        "public_id": "01a11a1d-8e88-75f1-a5fd-6ccab6df3992",
        "storage_key": "property/6767906449167165/01a11a1d-8e88-75f1-a5fd-6ccab6df3992.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy the cozy ambiance of your new apartment with a fireplace and modern kitchen finishes. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Kitchen counter with place settings and a view of the living room with a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites  (34).jpg"
    },
    {
      "id": "ec_6fb88f1526a0ef9899c54a94",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-9c1e-7788-b4af-b73b7a8ecad0.webp",
      "image_media": {
        "alt_text": "Dining nook with bar stools and a glass table, overlooking a balcony and greenery.",
        "public_id": "01a11a1d-9c1e-7788-b4af-b73b7a8ecad0",
        "storage_key": "property/6767906449167165/01a11a1d-9c1e-7788-b4af-b73b7a8ecad0.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or a casual meal in this charming dining nook, complete with a stylish glass table and comfortable bar stools. Large windows offer views of the surrounding greenery and the property's exterior.",
      "link": "false",
      "alt_text": "Dining nook with bar stools and a glass table, overlooking a balcony and greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites  (33).jpg"
    },
    {
      "id": "ec_eef6952e0771d712803edbeb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-9f0b-7726-8f44-3ea1c6ac62f3.webp",
      "image_media": {
        "alt_text": "Bedroom with queen bed, nightstand, and closet",
        "public_id": "01a11a1d-9f0b-7726-8f44-3ea1c6ac62f3",
        "storage_key": "property/6767906449167165/01a11a1d-9f0b-7726-8f44-3ea1c6ac62f3.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A comfortable and inviting bedroom featuring a queen-size bed with plush linens, a wooden nightstand with a lamp, and a spacious closet for storage.",
      "link": "false",
      "alt_text": "Bedroom with queen bed, nightstand, and closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites  (32).jpg"
    },
    {
      "id": "ec_43e1404ac0c2d959575372f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-9e3f-759e-85ca-cf6802547903.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, closet, and view into a kitchen area.",
        "public_id": "01a11a1d-9e3f-759e-85ca-cf6802547903",
        "storage_key": "property/6767906449167165/01a11a1d-9e3f-759e-85ca-cf6802547903.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this spacious bedroom featuring a comfortable queen-size bed, ample closet space, and a convenient view into the kitchen area.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, closet, and view into a kitchen area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites  (30).jpg"
    },
    {
      "id": "ec_afab340cacdb06e8518984b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-ab8d-713e-884d-5ba57240aa16.webp",
      "image_media": {
        "alt_text": "Bathroom with sink, toilet, and shower.",
        "public_id": "01a11a1d-ab8d-713e-884d-5ba57240aa16",
        "storage_key": "property/6767906449167165/01a11a1d-ab8d-713e-884d-5ba57240aa16.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a granite countertop, white sink, and a shower with a curtain.",
      "link": "false",
      "alt_text": "Bathroom with sink, toilet, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites  (29).jpg"
    },
    {
      "id": "ec_48b86caa4b271537c481bf2d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-aef9-753d-b474-cb45d12facd2.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a closet",
        "public_id": "01a11a1d-aef9-753d-b474-cb45d12facd2",
        "storage_key": "property/6767906449167165/01a11a1d-aef9-753d-b474-cb45d12facd2.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Convenient in-unit stackable washer and dryer located in a closet.",
      "link": "false",
      "alt_text": "Stackable washer and dryer in a closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites  (31).jpg"
    },
    {
      "id": "ec_0d5cc181105732311edfffaf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-b27f-7549-baac-80b0ab3d0670.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily building with balconies and trees.",
        "public_id": "01a11a1d-b27f-7549-baac-80b0ab3d0670",
        "storage_key": "property/6767906449167165/01a11a1d-b27f-7549-baac-80b0ab3d0670.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Explore the charming exterior of our multifamily property, featuring spacious balconies and lush greenery.",
      "link": "false",
      "alt_text": "Exterior view of a multifamily building with balconies and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites  (40).jpg"
    },
    {
      "id": "ec_04abe16f2371661957042255",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021a-49ed-77c0-95ef-6c531fea96ab.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-story apartment building with balconies and a garage.",
        "public_id": "019d021a-49ed-77c0-95ef-6c531fea96ab",
        "storage_key": "property/6767906449167165/019d021a-49ed-77c0-95ef-6c531fea96ab.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "View of the exterior of a modern apartment building featuring private balconies and an integrated garage entrance.",
      "link": "false",
      "alt_text": "Exterior of a multi-story apartment building with balconies and a garage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites  (38).jpg"
    },
    {
      "id": "ec_f64ffdc76ba7b4d58f0f985f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a11a1d-c352-76cc-ac87-84dbc623fd4c.webp",
      "image_media": {
        "alt_text": "Admiral's Cove Apartment Homes monument sign with building in background",
        "public_id": "01a11a1d-c352-76cc-ac87-84dbc623fd4c",
        "storage_key": "property/6767906449167165/01a11a1d-c352-76cc-ac87-84dbc623fd4c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Admiral's Cove Apartment Homes, featuring beautiful landscaping and building exteriors.",
      "link": "false",
      "alt_text": "Admiral's Cove Apartment Homes monument sign with building in background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Admirals-Cove_Favorites  (36).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_7098c3f9-16b3-4be5-880f-6bbb1a938736",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Cafecito Bonito",
      "poi_type": "Restaurants",
      "poi_address": "6307 DeBarr Rd A, Anchorage, AK 99504, USA",
      "poi_short_description": "Warm, cute coffeehouse tucked away, known for its horchata latte and pastries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-85fa-71cd-a98b-d0ea76834713.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-85fa-71cd-a98b-d0ea76834713",
        "storage_key": "property/6767906449167165/01a10ddf-85fa-71cd-a98b-d0ea76834713.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.instagram.com/cafecito_bonito_ak/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8387559026427044507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafecito-bonito",
      "poi_latitude": "61.21006409999999",
      "poi_longitude": "-149.7631398",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-240-6958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c332-71fb-82c4-eb1977f9675e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c332-71fb-82c4-eb1977f9675e",
        "storage_key": "property/6767906449167165/019d021e-c332-71fb-82c4-eb1977f9675e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ5SNNaRSXyFYRmyLOzn6YZnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_977be1e9-19b3-4bd8-8e94-5e2b24871a09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Hacienda Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6307 DeBarr Rd # G, Anchorage, AK 99504, USA",
      "poi_short_description": "Welcoming Mexican eatery serving flavorful fajitas, enchiladas, and signature margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-8324-7512-ad07-ba1bc03b48d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-8324-7512-ad07-ba1bc03b48d0",
        "storage_key": "property/6767906449167165/01a10ddf-8324-7512-ad07-ba1bc03b48d0.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.haciendamexican.restaurant/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8178659027894915516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hacienda-mexican-restaurant",
      "poi_latitude": "61.20993989999999",
      "poi_longitude": "-149.762957",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-338-6109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c33e-7249-bd94-3ce9a4f1afb4",
        "storage_key": "property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwLdf5GWyFYRvNG3sA1vgHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_a1008e52-dffc-49f0-9f66-797cbda6d733",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Great Alaska Pizza Co",
      "poi_type": "Restaurants",
      "poi_address": "6311 DeBarr Rd S, Anchorage, AK 99504, USA",
      "poi_short_description": "Pizzeria chain serving a menu of classic pies, wings & breadsticks in a low-key setting.",
      "poi_long_description": "Pizzeria chain serving a menu of classic pies, wings & breadsticks in a low-key setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-8240-747c-8978-7fc989f7aeb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-8240-747c-8978-7fc989f7aeb3",
        "storage_key": "property/6767906449167165/01a10ddf-8240-747c-8978-7fc989f7aeb3.webp",
        "width": 819,
        "height": 545
      },
      "poi_business_url": "http://www.greatalaskapizzacompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12977148615757751787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-alaska-pizza-co",
      "poi_latitude": "61.2101628",
      "poi_longitude": "-149.7619934",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-337-3733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c33e-7249-bd94-3ce9a4f1afb4",
        "storage_key": "property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNxhC0ZOWyFYR62Wx_-gXGLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_f903b37d-e929-45b8-97a6-51ee459594d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "My Shawarma House",
      "poi_type": "Restaurants",
      "poi_address": "6311 DeBarr Rd #L3, Anchorage, AK 99504, USA",
      "poi_short_description": "Family-owned Mediterranean restaurant serving flavorful Halal shawarma wraps and plates.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-8338-7219-9df3-5b923d4c7c93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-8338-7219-9df3-5b923d4c7c93",
        "storage_key": "property/6767906449167165/01a10ddf-8338-7219-9df3-5b923d4c7c93.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://food.orders.co/zgq83dmk/menu",
      "poi_directions_map_url": "https://maps.google.com/?cid=1255758554656389331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "my-shawarma-house",
      "poi_latitude": "61.21047659999999",
      "poi_longitude": "-149.7622386",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-677-0775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c33e-7249-bd94-3ce9a4f1afb4",
        "storage_key": "property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8y6RgCXyFYR07jzjcBZbRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3f738179-7424-45a9-b5a0-1b35224158a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Pedro's Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "1565 Bragaw St Ste 103, Anchorage, AK 99508, USA",
      "poi_short_description": "Authentic Mexican eatery serving traditional tacos and signature churros.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-8642-727d-a4e5-98bdca247465.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-8642-727d-a4e5-98bdca247465",
        "storage_key": "property/6767906449167165/01a10ddf-8642-727d-a4e5-98bdca247465.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pedros-mexicangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8879496700492779828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pedros-mexican-grill",
      "poi_latitude": "61.2069238",
      "poi_longitude": "-149.8076981",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-222-4676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c33e-7249-bd94-3ce9a4f1afb4",
        "storage_key": "property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNa6KsIiXyFYRNBEgGTRPOns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b535fb88-0dfe-4ee0-b6df-4dd952ef6d9f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Denny's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3950 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "Casual diner chain dishing up classic American comfort fare, including all-day breakfast favorites.",
      "poi_long_description": "Casual diner chain dishing up classic American comfort fare, including all-day breakfast favorites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-851a-7109-9cf7-41bcb9ff2c55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-851a-7109-9cf7-41bcb9ff2c55",
        "storage_key": "property/6767906449167165/01a10ddf-851a-7109-9cf7-41bcb9ff2c55.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.dennys.com/AK/ANCHORAGE/249002?utm_source=G&utm_medium=organic&utm_campaign=DAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=17647063131336925478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dennys-restaurant",
      "poi_latitude": "61.20953120000001",
      "poi_longitude": "-149.806752",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 833-551-6229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c33e-7249-bd94-3ce9a4f1afb4",
        "storage_key": "property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd8fPpV6WyFYRJuE6eGv25vQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_caa0f000-f764-40df-9ad5-59fd72b30a79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Snow City Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1034 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_long_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-82f7-747c-8acd-81849f2e1c3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-82f7-747c-8acd-81849f2e1c3d",
        "storage_key": "property/6767906449167165/01a10ddf-82f7-747c-8acd-81849f2e1c3d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snowcitycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2005746570144512581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snow-city-cafe",
      "poi_latitude": "61.2184015",
      "poi_longitude": "-149.9033331",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-272-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c332-71fb-82c4-eb1977f9675e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c332-71fb-82c4-eb1977f9675e",
        "storage_key": "property/6767906449167165/019d021e-c332-71fb-82c4-eb1977f9675e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJQcnnU4G9yFYRRfrr7uDX1Rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_f01668df-a18e-4fb1-986e-adad18de8646",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Orso",
      "poi_type": "Restaurants",
      "poi_address": "737 W 5th Ave #110, Anchorage, AK 99501, USA",
      "poi_short_description": "A menu of local seafood & grilled meats, as well as 20+ wines by the glass, in a welcoming space.",
      "poi_long_description": "A menu of local seafood & grilled meats, as well as 20+ wines by the glass, in a welcoming space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-840a-7604-ba32-b754d3689952.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-840a-7604-ba32-b754d3689952",
        "storage_key": "property/6767906449167165/01a10ddf-840a-7604-ba32-b754d3689952.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://orsoalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9688852827403958754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orso",
      "poi_latitude": "61.2176833",
      "poi_longitude": "-149.8961662",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-222-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c33e-7249-bd94-3ce9a4f1afb4",
        "storage_key": "property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bXHMYe9yFYR4rlzElC4dYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_59508114-5763-4628-ab55-75919f9a8e8b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Glacier Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "737 W 5th Ave #110, Anchorage, AK 99501, USA",
      "poi_short_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_long_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddd-7b42-744f-9419-1a480e7e5dad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddd-7b42-744f-9419-1a480e7e5dad",
        "storage_key": "property/6767906449167165/01a10ddd-7b42-744f-9419-1a480e7e5dad.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://glacierbrewhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7378027105723896693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glacier-brewhouse",
      "poi_latitude": "61.21784590000001",
      "poi_longitude": "-149.8964654",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-274-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c33e-7249-bd94-3ce9a4f1afb4",
        "storage_key": "property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bXHMYe9yFYRdVPg648EZGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_7ad6bd2d-42ff-4eb4-b225-b5d8b172b48f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Moose's Tooth Pub & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3300 Old Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_long_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddd-7b32-71d8-a321-bef9973f6779.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddd-7b32-71d8-a321-bef9973f6779",
        "storage_key": "property/6767906449167165/01a10ddd-7b32-71d8-a321-bef9973f6779.webp",
        "width": 1280,
        "height": 889
      },
      "poi_business_url": "https://www.moosestoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15494600602096929900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mooses-tooth-pub--pizzeria",
      "poi_latitude": "61.1905009",
      "poi_longitude": "-149.8691037",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-258-2537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c33e-7249-bd94-3ce9a4f1afb4",
        "storage_key": "property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wBgzrmXyFYRbIyKWCfhB9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_2bcc18c4-1811-4b13-a6e3-525741d72550",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Spenard Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1049 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_long_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021f-1f0b-75b0-9ceb-7736041649f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-1f0b-75b0-9ceb-7736041649f4",
        "storage_key": "property/6767906449167165/019d021f-1f0b-75b0-9ceb-7736041649f4.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.spenardroadhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10079478686688268729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spenard-roadhouse",
      "poi_latitude": "61.19552819999999",
      "poi_longitude": "-149.9032167",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-770-7623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c33e-7249-bd94-3ce9a4f1afb4",
        "storage_key": "property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRAGpNuXyFYRudEsUXaA4Ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_697a90d9-09e4-48b1-95af-b91cf3dd24da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Gwennie's Old Alaska Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4333 Spenard Rd, Anchorage, AK 99517, USA",
      "poi_short_description": "Home cooking & all-day breakfasts in an eatery filled with knickknacks, native art & old photos.",
      "poi_long_description": "Home cooking & all-day breakfasts in an eatery filled with knickknacks, native art & old photos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-92b8-748c-bef2-abc04563d573.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-92b8-748c-bef2-abc04563d573",
        "storage_key": "property/6767906449167165/01a10ddf-92b8-748c-bef2-abc04563d573.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gwenniesoldalaskarestaurant.top/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15781866237967564527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwennies-old-alaska-restaurant",
      "poi_latitude": "61.1818463",
      "poi_longitude": "-149.9327172",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-243-2090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c33e-7249-bd94-3ce9a4f1afb4",
        "storage_key": "property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXZvL-OXyFYR737JPrpzBNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_306c1731-e733-40b7-a0e5-281fbeb5be6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Ginger",
      "poi_type": "Restaurants",
      "poi_address": "425 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Stylish restaurant & lounge specializing in Pacific Rim cuisine, plus microbrews & cocktails.",
      "poi_long_description": "Stylish restaurant & lounge specializing in Pacific Rim cuisine, plus microbrews & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-8850-70cc-8440-94b2bb7a7625.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-8850-70cc-8440-94b2bb7a7625",
        "storage_key": "property/6767906449167165/01a10ddf-8850-70cc-8440-94b2bb7a7625.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.gingeralaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1970017419952325841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ginger",
      "poi_latitude": "61.217691",
      "poi_longitude": "-149.8905035",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-929-3680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c33e-7249-bd94-3ce9a4f1afb4",
        "storage_key": "property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyxXi3CmWyFYR0QSX5WfoVhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_296c2a1d-194c-49df-9798-e922957c3867",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "F Street Station",
      "poi_type": "Restaurants",
      "poi_address": "325 F St, Anchorage, AK 99501, USA",
      "poi_short_description": "Low-key bar serving up seafood & draft beer, plus a weekend brunch with a popular eggs Benedict.",
      "poi_long_description": "Low-key bar serving up seafood & draft beer, plus a weekend brunch with a popular eggs Benedict.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-8c13-725e-9ec6-ed26ed45fb57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-8c13-725e-9ec6-ed26ed45fb57",
        "storage_key": "property/6767906449167165/01a10ddf-8c13-725e-9ec6-ed26ed45fb57.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "https://fstreetstation.website/",
      "poi_directions_map_url": "https://maps.google.com/?cid=497107031803204211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f-street-station",
      "poi_latitude": "61.2189375",
      "poi_longitude": "-149.8931451",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-272-5196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c33e-7249-bd94-3ce9a4f1afb4",
        "storage_key": "property/6767906449167165/019d021e-c33e-7249-bd94-3ce9a4f1afb4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtc6fbYe9yFYRc5L6LTYU5gY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_c0b8e97a-e8f6-4f0c-8221-64d6342e698b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "5501 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Convenience store with freshly brewed coffee, and breakfast and hot food.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-8e6f-7519-abca-cbf022376992.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-8e6f-7519-abca-cbf022376992",
        "storage_key": "property/6767906449167165/01a10ddf-8e6f-7519-abca-cbf022376992.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/anchorage/5501-debarr-rd/2746637?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3405943232955952120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "61.21029979999999",
      "poi_longitude": "-149.777406",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-333-9869",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c337-70eb-80be-8f145115b41f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c337-70eb-80be-8f145115b41f",
        "storage_key": "property/6767906449167165/019d021e-c337-70eb-80be-8f145115b41f.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJsZYz-oyWyFYR-Ct8LVNXRC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_584b7b8c-1965-42e5-a352-d94b0ef33305",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Carrs",
      "poi_type": "Shopping & Retail",
      "poi_address": "5600 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_long_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-6c25-707b-a77b-78988e76d17e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-6c25-707b-a77b-78988e76d17e",
        "storage_key": "property/6767906449167165/019d021e-6c25-707b-a77b-78988e76d17e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.carrsqc.com/ak/anchorage/5600-debarr-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4664412945575878724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs",
      "poi_latitude": "61.2081423",
      "poi_longitude": "-149.7770172",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-339-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-99cba7ee0eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-99cba7ee0eca",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-99cba7ee0eca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcVWUPI2WyFYRRKDIYtxSu0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d2204b5b-505f-4725-9098-a727f66e66fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-8cf5-76b9-9b93-626b0898c8e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-8cf5-76b9-9b93-626b0898c8e0",
        "storage_key": "property/6767906449167165/01a10ddf-8cf5-76b9-9b93-626b0898c8e0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/anchorage-ak-pharmacies/1200-n-muldoon-rd-anchorage-ak-99504/storeid=17435?WT.mc_id=LS_GOOGLE_RX_17435",
      "poi_directions_map_url": "https://maps.google.com/?cid=2401999348130175879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "61.22616159999999",
      "poi_longitude": "-149.7460372",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-332-1004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6d1-76d8-9b80-dc255e277ac4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6d1-76d8-9b80-dc255e277ac4",
        "storage_key": "property/6767906449167165/019d021e-c6d1-76d8-9b80-dc255e277ac4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvwOC3yeUyFYRh9sESK6dVSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_cd0c2c0b-0cd4-4bf6-aba7-07bc202d037c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "7701 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-705d-7161-8628-b3135d2f1cf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-705d-7161-8628-b3135d2f1cf8",
        "storage_key": "property/6767906449167165/019d021e-705d-7161-8628-b3135d2f1cf8.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/ak/anchorage/muldoon/701/00018?cid=loc_70100018_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6875232166619000959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "61.2115208",
      "poi_longitude": "-149.7367644",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-269-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-99cba7ee0eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-99cba7ee0eca",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-99cba7ee0eca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1aeEJaOWyFYRfzCqnzq7aV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_82640ece-3b7c-458a-a5e5-4d691ef7b8a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7405 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "One-stop department store offering a wide selection of household items and electronics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-6eef-7332-bffe-6ea14f70e752.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-6eef-7332-bffe-6ea14f70e752",
        "storage_key": "property/6767906449167165/019d021e-6eef-7332-bffe-6ea14f70e752.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4359-anchorage-ak/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18253871179416217585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "61.2118328",
      "poi_longitude": "-149.7435267",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-339-9039",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6ca-73bf-933a-8292b3e02ee2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6ca-73bf-933a-8292b3e02ee2",
        "storage_key": "property/6767906449167165/019d021e-c6ca-73bf-933a-8292b3e02ee2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI7PFF5iWyFYR8SfY4B_HUv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_3f028a48-e36f-4feb-a58f-f7cb3eec220d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "4125 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-8cf5-76b9-9b93-66ff1eddbe1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-8cf5-76b9-9b93-66ff1eddbe1c",
        "storage_key": "property/6767906449167165/01a10ddf-8cf5-76b9-9b93-66ff1eddbe1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/w/-/ak/anchorage/63",
      "poi_directions_map_url": "https://maps.google.com/?cid=6167457813750908994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "61.2109639",
      "poi_longitude": "-149.8048228",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-269-9510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6ca-73bf-933a-8292b3e02ee2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6ca-73bf-933a-8292b3e02ee2",
        "storage_key": "property/6767906449167165/019d021e-c6ca-73bf-933a-8292b3e02ee2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoYf74l6WyFYRQojUezQ2l1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_85ae2d38-10ff-4086-ac4b-9e33f43dd7a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "7600 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-8f43-708d-bcb4-cc41bd889275.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-8f43-708d-bcb4-cc41bd889275",
        "storage_key": "property/6767906449167165/01a10ddf-8f43-708d-bcb4-cc41bd889275.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-7600+debarr+rd-anchorage-ak-99504/id=12679",
      "poi_directions_map_url": "https://maps.google.com/?cid=3791094009670797855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "61.2091817",
      "poi_longitude": "-149.7393566",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-771-9920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccce-708f-882a-214184819b48",
        "storage_key": "property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1qS372XyFYRHwqKbOqrnDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_517f6c47-e4ae-46e8-b8e3-92a46c377010",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 N Muldoon Rd Ste F, Anchorage, AK 99504, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-750f-7438-9540-4bcc9d9d3096.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-750f-7438-9540-4bcc9d9d3096",
        "storage_key": "property/6767906449167165/019d021e-750f-7438-9540-4bcc9d9d3096.webp",
        "width": 1280,
        "height": 981
      },
      "poi_business_url": "https://www.target.com/sl/anchorage-ne/2371",
      "poi_directions_map_url": "https://maps.google.com/?cid=4266841454106128535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "61.2262581",
      "poi_longitude": "-149.7467627",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-269-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6ca-73bf-933a-8292b3e02ee2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6ca-73bf-933a-8292b3e02ee2",
        "storage_key": "property/6767906449167165/019d021e-c6ca-73bf-933a-8292b3e02ee2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ50LtKyaUyFYRlzDoILLdNjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_51a4d361-fdf6-4aeb-b50b-08c26191bc88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-8ed6-73e8-9d3e-1a15130ed5f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-8ed6-73e8-9d3e-1a15130ed5f6",
        "storage_key": "property/6767906449167165/01a10ddf-8ed6-73e8-9d3e-1a15130ed5f6.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/AK-Anchorage/2955?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2955-_-na-_-0-_-0&y_source=1_MTE4NDMzNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5609176981201015203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "61.2296221",
      "poi_longitude": "-149.7460514",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-269-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6ca-73bf-933a-8292b3e02ee2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6ca-73bf-933a-8292b3e02ee2",
        "storage_key": "property/6767906449167165/019d021e-c6ca-73bf-933a-8292b3e02ee2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN-ud4SWUyFYRo9HI5r7M100",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_783dbae3-679b-49d6-a2d2-b37e4812c49b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Tikahtnu Commons",
      "poi_type": "Shopping & Retail",
      "poi_address": "1142 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Expansive shopping center featuring a variety of retail stores, restaurants, and a movie theater.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-91ec-7104-bc08-c4f54af25045.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-91ec-7104-bc08-c4f54af25045",
        "storage_key": "property/6767906449167165/01a10ddf-91ec-7104-bc08-c4f54af25045.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://tikahtnucommons.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4413898816297472885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tikahtnu-commons",
      "poi_latitude": "61.2285985",
      "poi_longitude": "-149.7419444",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6ca-73bf-933a-8292b3e02ee2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6ca-73bf-933a-8292b3e02ee2",
        "storage_key": "property/6767906449167165/019d021e-c6ca-73bf-933a-8292b3e02ee2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8dy9OSaUyFYRdZPta5ZRQT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b368007d-781e-405e-99fa-2c7761657a44",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Ptarmigan Elementary School",
      "poi_type": "Education",
      "poi_address": "888 Edward St, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-9065-75db-b33b-1d48bd1dc8db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-9065-75db-b33b-1d48bd1dc8db",
        "storage_key": "property/6767906449167165/01a10ddf-9065-75db-b33b-1d48bd1dc8db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/ptarmigan",
      "poi_directions_map_url": "https://maps.google.com/?cid=8593156068931633944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ptarmigan-elementary-school",
      "poi_latitude": "61.21426769999999",
      "poi_longitude": "-149.7648965",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-742-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-954b19ef1172",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-aC30o-WyFYRGIMpjOoFQXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_051a5629-0d2f-4146-878e-a5b5865ee856",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Clark Middle School",
      "poi_type": "Education",
      "poi_address": "150 Bragaw St, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-927e-714c-b802-48510352af54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-927e-714c-b802-48510352af54",
        "storage_key": "property/6767906449167165/01a10ddf-927e-714c-b802-48510352af54.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://clark.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3194748686231896837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clark-middle-school",
      "poi_latitude": "61.2228308",
      "poi_longitude": "-149.8110892",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-742-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-954b19ef1172",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGQm1AG-WyFYRBYN_7QAHViw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_edecdae6-896f-4751-ae12-587164544eaf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Bartlett High School",
      "poi_type": "Education",
      "poi_address": "1101 Golden Bear Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-94ac-7215-80cf-a6e33d0cc88c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-94ac-7215-80cf-a6e33d0cc88c",
        "storage_key": "property/6767906449167165/01a10ddf-94ac-7215-80cf-a6e33d0cc88c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/bartlett",
      "poi_directions_map_url": "https://maps.google.com/?cid=846529779845035471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bartlett-high-school",
      "poi_latitude": "61.2325666",
      "poi_longitude": "-149.733236",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-742-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-954b19ef1172",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa5cL-SWUyFYRz_Vzg1l6vws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f99b970b-9225-4d6b-942b-8a3bb4de2427",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Susitna Elementary School",
      "poi_type": "Education",
      "poi_address": "7500 Tyone Ct, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/susitna",
      "poi_directions_map_url": "https://maps.google.com/?cid=17311750026139150920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "susitna-elementary-school",
      "poi_latitude": "61.19822119999999",
      "poi_longitude": "-149.737894",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-742-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-954b19ef1172",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvTdoebiWyFYRSCpiXO2wP_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_8bc2dc10-6d80-4bee-83ea-dbf871ad5689",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Begich Middle School",
      "poi_type": "Education",
      "poi_address": "7440 Creekside Center Drive, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-945b-76e3-ba1d-33ee9b520041.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-945b-76e3-ba1d-33ee9b520041",
        "storage_key": "property/6767906449167165/01a10ddf-945b-76e3-ba1d-33ee9b520041.webp",
        "width": 960,
        "height": 637
      },
      "poi_business_url": "https://www.asdk12.org/begich",
      "poi_directions_map_url": "https://maps.google.com/?cid=7141988370800961682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "begich-middle-school",
      "poi_latitude": "61.2080642",
      "poi_longitude": "-149.7430092",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-954b19ef1172",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjWKGIJaWyFYRkuiPV5VwHWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_cd5df18f-9f0b-4383-b768-1d8fce3e502b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Nunaka Valley Elementary School",
      "poi_type": "Education",
      "poi_address": "1905 Twining Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/nunakavalley",
      "poi_directions_map_url": "https://maps.google.com/?cid=10832205280320051432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nunaka-valley-elementary-school",
      "poi_latitude": "61.20318089999999",
      "poi_longitude": "-149.7761699",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-742-0366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-954b19ef1172",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP9thoO2WyFYR6FiWm0-5U5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5f8cabf1-0026-460a-bd3f-41d32eb8b64a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Anchorage Waldorf School",
      "poi_type": "Education",
      "poi_address": "3250 Baxter Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-95a8-7118-84c4-d52f80d0436e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-95a8-7118-84c4-d52f80d0436e",
        "storage_key": "property/6767906449167165/01a10ddf-95a8-7118-84c4-d52f80d0436e.webp",
        "width": 940,
        "height": 788
      },
      "poi_business_url": "http://waldorfak.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18361981143723653720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-waldorf-school",
      "poi_latitude": "61.191018",
      "poi_longitude": "-149.764458",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-333-9062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-954b19ef1172",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsQvwMt2WyFYRWLoRdJDc0v4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_277b7e68-f291-4b55-8b62-d0d8d172afab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Carousel Child Care Center",
      "poi_type": "Education",
      "poi_address": "6370 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Daycare serving children ages 12 months to 11 years with full- or part-time programs and outdoor activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-96b7-743d-a91c-1a6e9a4658b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-96b7-743d-a91c-1a6e9a4658b0",
        "storage_key": "property/6767906449167165/01a10ddf-96b7-743d-a91c-1a6e9a4658b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.akcarouselccc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9679261330861443036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carousel-child-care-center",
      "poi_latitude": "61.20940239999999",
      "poi_longitude": "-149.7619198",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-333-1231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-954b19ef1172",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP36UxJOWyFYR3McrwuWkU4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_01d4ed40-91bf-4290-af6d-ee535b5cee5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Kids' Corps, Inc. Muldoon- HS",
      "poi_type": "Education",
      "poi_address": "1251 Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-97fc-752f-b662-55a65b5d781f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-97fc-752f-b662-55a65b5d781f",
        "storage_key": "property/6767906449167165/01a10ddf-97fc-752f-b662-55a65b5d781f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcialaska.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5142224924075639402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-corps-inc-muldoon--hs",
      "poi_latitude": "61.2105609",
      "poi_longitude": "-149.7304155",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-333-5433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-954b19ef1172",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ3VDR6OWyFYRakKw4lLaXEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_806ef225-6298-43a0-b414-353bb4bb5070",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Joy Greisen Jewish Education Center",
      "poi_type": "Education",
      "poi_address": "7525 E Northern Lights Blvd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-960f-7168-832c-00f08c44307f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-960f-7168-832c-00f08c44307f",
        "storage_key": "property/6767906449167165/01a10ddf-960f-7168-832c-00f08c44307f.webp",
        "width": 833,
        "height": 295
      },
      "poi_business_url": "https://www.jecalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10646827205177246254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joy-greisen-jewish-education-center",
      "poi_latitude": "61.1963656",
      "poi_longitude": "-149.7400634",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-337-1672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-954b19ef1172",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIzgLvMeWyFYRLgKODe8gwZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_8420b54a-d990-4a74-85b1-5fbb9dd34c2d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Regal Tikahtnu",
      "poi_type": "Entertainment",
      "poi_address": "1102 N Muldoon Rd B, Anchorage, AK 99504, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-9867-769c-ad95-f118f602835b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-9867-769c-ad95-f118f602835b",
        "storage_key": "property/6767906449167165/01a10ddf-9867-769c-ad95-f118f602835b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-tikahtnu-1994?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13354331969552968589&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-tikahtnu",
      "poi_latitude": "61.22698",
      "poi_longitude": "-149.74081",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-d002-77e6-a1ea-78fb00dad12c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-d002-77e6-a1ea-78fb00dad12c",
        "storage_key": "property/6767906449167165/019d021e-d002-77e6-a1ea-78fb00dad12c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ68J5iyaUyFYRjevYCSweVLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_748ade13-17c0-4f45-8e8e-f6fe1706cdd4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Alaska Native Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8800 Heritage Center Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_long_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-8999-7681-877d-383cef1311d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-8999-7681-877d-383cef1311d6",
        "storage_key": "property/6767906449167165/019d021e-8999-7681-877d-383cef1311d6.webp",
        "width": 992,
        "height": 744
      },
      "poi_business_url": "http://www.alaskanative.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2030269464598956769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-heritage-center",
      "poi_latitude": "61.2327673",
      "poi_longitude": "-149.7172142",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-330-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccd1-7297-8305-6c2c46cd18a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccd1-7297-8305-6c2c46cd18a1",
        "storage_key": "property/6767906449167165/019d021e-ccd1-7297-8305-6c2c46cd18a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0B1BT2UyFYR4Uq-O1L3LBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_5b2a219c-c6be-4a07-a580-e44dc36653ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Alaska Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "4721 Aircraft Dr, Anchorage, AK 99502, USA",
      "poi_short_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_long_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-986b-743c-949a-580e2b1d54f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-986b-743c-949a-580e2b1d54f9",
        "storage_key": "property/6767906449167165/01a10ddf-986b-743c-949a-580e2b1d54f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskaairmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15162667059188171085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-aviation-museum",
      "poi_latitude": "61.1793565",
      "poi_longitude": "-149.9719066",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 907-248-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccd1-7297-8305-6c2c46cd18a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccd1-7297-8305-6c2c46cd18a1",
        "storage_key": "property/6767906449167165/019d021e-ccd1-7297-8305-6c2c46cd18a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJExnfV029yFYRTYFt5lqdbNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_de1851d7-ee99-4dae-b2fb-47e8fd0d792d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Alaska Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4601 Campbell Airstrip Road, Anchorage, AK 99507, USA",
      "poi_short_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_long_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddd-8a0b-7702-80be-03804f31f53b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddd-8a0b-7702-80be-03804f31f53b",
        "storage_key": "property/6767906449167165/01a10ddd-8a0b-7702-80be-03804f31f53b.webp",
        "width": 976,
        "height": 662
      },
      "poi_business_url": "http://www.alaskabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5929108756512643080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-botanical-garden",
      "poi_latitude": "61.17777439999999",
      "poi_longitude": "-149.7615572",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-770-3692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddd-9a17-77ba-a7d8-c6a3b9fc8582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10ddd-9a17-77ba-a7d8-c6a3b9fc8582",
        "storage_key": "property/6767906449167165/01a10ddd-9a17-77ba-a7d8-c6a3b9fc8582.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-wU15deWyFYRCBiYEgBtSFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_c08e00f6-6a93-418c-8e30-c6b85ed534a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Alaska Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4731 O'Malley Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_long_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddd-7edd-70bd-8868-d0e8a2ee0e3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddd-7edd-70bd-8868-d0e8a2ee0e3c",
        "storage_key": "property/6767906449167165/01a10ddd-7edd-70bd-8868-d0e8a2ee0e3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640787335481525738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-zoo",
      "poi_latitude": "61.1238025",
      "poi_longitude": "-149.7907",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddd-9a16-759c-9349-a4fb2ebe47f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10ddd-9a16-759c-9349-a4fb2ebe47f5",
        "storage_key": "property/6767906449167165/01a10ddd-9a16-759c-9349-a4fb2ebe47f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH2Yh-ASayFYR6gU-9WdijKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_3719a202-ae89-4e42-8ef2-535950a8a3f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Anchorage Museum",
      "poi_type": "Entertainment",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_long_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddd-7c10-708d-a569-c894fc7422d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddd-7c10-708d-a569-c894fc7422d0",
        "storage_key": "property/6767906449167165/01a10ddd-7c10-708d-a569-c894fc7422d0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.anchoragemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288654669058341295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-museum",
      "poi_latitude": "61.2162281",
      "poi_longitude": "-149.8855791",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-929-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccd1-7297-8305-6c2c46cd18a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccd1-7297-8305-6c2c46cd18a1",
        "storage_key": "property/6767906449167165/019d021e-ccd1-7297-8305-6c2c46cd18a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYRr_lSUBrKRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_04ece867-d13b-424c-9c43-766c9951cc2f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Alaska Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "621 W 6th Ave Suite ACPA, Anchorage, AK 99501, USA",
      "poi_short_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_long_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-9991-712d-a55a-3d7df4d7fe34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-9991-712d-a55a-3d7df4d7fe34",
        "storage_key": "property/6767906449167165/01a10ddf-9991-712d-a55a-3d7df4d7fe34.webp",
        "width": 1152,
        "height": 648
      },
      "poi_business_url": "https://www.alaskapac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14135362058056830395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-center-for-the-performing-arts",
      "poi_latitude": "61.2170565",
      "poi_longitude": "-149.8943133",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-263-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-b768-77af-9e41-aa4e6663709b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10ddf-b768-77af-9e41-aa4e6663709b",
        "storage_key": "property/6767906449167165/01a10ddf-b768-77af-9e41-aa4e6663709b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcZ2Uoe9yFYRuw0DQubkKsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_c9a6edd3-a4a7-4b7b-b9f6-88a21cb0b60d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Bear Tooth Theatrepub",
      "poi_type": "Entertainment",
      "poi_address": "1230 W 27th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_long_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-9b6d-76c5-8ec7-661caad4c22e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-9b6d-76c5-8ec7-661caad4c22e",
        "storage_key": "property/6767906449167165/01a10ddf-9b6d-76c5-8ec7-661caad4c22e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beartoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145190151877577635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-tooth-theatrepub",
      "poi_latitude": "61.1959573",
      "poi_longitude": "-149.9070452",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-d002-77e6-a1ea-78fb00dad12c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-d002-77e6-a1ea-78fb00dad12c",
        "storage_key": "property/6767906449167165/019d021e-d002-77e6-a1ea-78fb00dad12c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_p-3NuXyFYRo0t0DbH0yow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_870dcfe4-1c7e-4873-b4dd-04420cbf15f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Alaska Museum of Science and Nature",
      "poi_type": "Entertainment",
      "poi_address": "201 N Bragaw St, Anchorage, AK 99508, USA",
      "poi_short_description": "Museum exploring Alaska's natural history, with dinosaur fossils & hands-on displays for kids.",
      "poi_long_description": "Museum exploring Alaska's natural history, with dinosaur fossils & hands-on displays for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddd-83e1-71de-a849-70d1dc3be15f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddd-83e1-71de-a849-70d1dc3be15f",
        "storage_key": "property/6767906449167165/01a10ddd-83e1-71de-a849-70d1dc3be15f.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "http://www.alaskamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16255560840695787410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-museum-of-science-and-nature",
      "poi_latitude": "61.22514929999999",
      "poi_longitude": "-149.8078589",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-274-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccd1-7297-8305-6c2c46cd18a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccd1-7297-8305-6c2c46cd18a1",
        "storage_key": "property/6767906449167165/019d021e-ccd1-7297-8305-6c2c46cd18a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99EwrG-WyFYRki9sfnVal-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_033defb2-fb9a-4718-b073-dd2e8336b9da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Far North Bicentennial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4970 Campbell Airstrip Road, Anchorage, AK 99507, USA",
      "poi_short_description": "Popular 4,000-acre park with 100-plus miles of multi-use trails, skiing, a botanical garden & more.",
      "poi_long_description": "Popular 4,000-acre park with 100-plus miles of multi-use trails, skiing, a botanical garden & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-9e7a-7511-8b2e-33d6ff977e24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-9e7a-7511-8b2e-33d6ff977e24",
        "storage_key": "property/6767906449167165/01a10ddf-9e7a-7511-8b2e-33d6ff977e24.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1862495611458923156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "far-north-bicentennial-park",
      "poi_latitude": "61.1559064",
      "poi_longitude": "-149.7514649",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-cb02-76eb-bb4f-3f79a0d63faf",
        "storage_key": "property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2OHIzSXyFYRlKq7BOTp2Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_1af9c684-0088-4951-b972-955bfc88448a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Alaska Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-981c-7517-bca1-79b183b1f1ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-981c-7517-bca1-79b183b1f1ad",
        "storage_key": "property/6767906449167165/019d021e-981c-7517-bca1-79b183b1f1ad.webp",
        "width": 911,
        "height": 512
      },
      "poi_business_url": "https://www.alaskaregional.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047679142014347636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-regional-hospital",
      "poi_latitude": "61.2107038",
      "poi_longitude": "-149.8288584",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-276-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-d2c2-73c0-88f2-71531382be54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-d2c2-73c0-88f2-71531382be54",
        "storage_key": "property/6767906449167165/019d021e-d2c2-73c0-88f2-71531382be54.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYPSVUSWyFYRdOlZ-qAaig4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_488ec8d7-fa09-4f4c-b0be-e436a09b2917",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Providence Alaska Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddd-8a25-73ce-a341-c95be03d6c61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddd-8a25-73ce-a341-c95be03d6c61",
        "storage_key": "property/6767906449167165/01a10ddd-8a25-73ce-a341-c95be03d6c61.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.providence.org/locations/ak/alaska-medical-center?ls=location&y_source=1_OTU3NTY4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990875543032169585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-alaska-medical-center",
      "poi_latitude": "61.1866256",
      "poi_longitude": "-149.8221354",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-562-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-d2c2-73c0-88f2-71531382be54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-d2c2-73c0-88f2-71531382be54",
        "storage_key": "property/6767906449167165/019d021e-d2c2-73c0-88f2-71531382be54.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__razgCXyFYRcQRyHsICoRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_32774880-5f14-4d37-9352-416d9cd2a158",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Patients First Medical Clinic LLC.",
      "poi_type": "Health and Wellness",
      "poi_address": "6307 DeBarr Rd # C, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-9bbf-7279-b470-817a9ac21ae7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-9bbf-7279-b470-817a9ac21ae7",
        "storage_key": "property/6767906449167165/01a10ddf-9bbf-7279-b470-817a9ac21ae7.webp",
        "width": 500,
        "height": 281
      },
      "poi_business_url": "https://www.providence.org/locations/ak/primary-care-debarr",
      "poi_directions_map_url": "https://maps.google.com/?cid=11743320548983164004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patients-first-medical-clinic-llc",
      "poi_latitude": "61.21004919999999",
      "poi_longitude": "-149.7631213",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-212-3420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccce-708f-882a-214184819b48",
        "storage_key": "property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwLdf5GWyFYRZMyvDdKn-KI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_78655be9-6a29-4962-a18f-300cb10c3980",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Providence Primary Care - DeBarr",
      "poi_type": "Health and Wellness",
      "poi_address": "6307 DeBarr Rd # C, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-9bf3-7476-9263-a6626e2da1f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-9bf3-7476-9263-a6626e2da1f8",
        "storage_key": "property/6767906449167165/01a10ddf-9bf3-7476-9263-a6626e2da1f8.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "https://www.providence.org/locations/ak/primary-care-debarr?Is=location&y_source=1_MjAzNDU1OTQ2OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3685784227342202930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-primary-care---debarr",
      "poi_latitude": "61.21004919999999",
      "poi_longitude": "-149.7631213",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-212-3420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccce-708f-882a-214184819b48",
        "storage_key": "property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeUKuGACXyFYRMjh4BTqJJjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_2e78bd78-dd37-4d2d-ae6a-c7e30e9c2b07",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Carrs Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5600 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-6c25-707b-a77b-78988e76d17e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-6c25-707b-a77b-78988e76d17e",
        "storage_key": "property/6767906449167165/019d021e-6c25-707b-a77b-78988e76d17e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.pharmacy.carrsqc.com/ak/anchorage/5600-debarr-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16081271465743249979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs-pharmacy",
      "poi_latitude": "61.2081545",
      "poi_longitude": "-149.7770566",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-339-0960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6d1-76d8-9b80-dc255e277ac4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6d1-76d8-9b80-dc255e277ac4",
        "storage_key": "property/6767906449167165/019d021e-c6d1-76d8-9b80-dc255e277ac4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcVWUPI2WyFYRO3JAJDInLN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_58b79100-f31f-4450-a81d-d89c9b58bee9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Costco Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4125 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-9d5d-72b8-8fc0-85c4738beda5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-9d5d-72b8-8fc0-85c4738beda5",
        "storage_key": "property/6767906449167165/01a10ddf-9d5d-72b8-8fc0-85c4738beda5.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.costco.com/w/-/ak/anchorage/63",
      "poi_directions_map_url": "https://maps.google.com/?cid=5304433873799662731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-pharmacy",
      "poi_latitude": "61.2115918",
      "poi_longitude": "-149.8045865",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-269-9503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6d1-76d8-9b80-dc255e277ac4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6d1-76d8-9b80-dc255e277ac4",
        "storage_key": "property/6767906449167165/019d021e-c6d1-76d8-9b80-dc255e277ac4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrZGHlF6WyFYRi8xgDoEinUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_07818a9b-2d1e-40f3-88a6-234ce8bb3633",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7405 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-9cda-71af-8b8a-b68703737572.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-9cda-71af-8b8a-b68703737572",
        "storage_key": "property/6767906449167165/019d021e-9cda-71af-8b8a-b68703737572.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/4359-anchorage-ak/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6994539045457241117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "61.2118328",
      "poi_longitude": "-149.7435267",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-339-9037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6d1-76d8-9b80-dc255e277ac4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6d1-76d8-9b80-dc255e277ac4",
        "storage_key": "property/6767906449167165/019d021e-c6d1-76d8-9b80-dc255e277ac4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI7PFF5iWyFYRHSQUBDSYEWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_44d9aabb-0f5c-477a-94f8-b7714dc4380d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "The Alaska Club East Gym & Pool",
      "poi_type": "Health and Wellness",
      "poi_address": "5201 E Tudor Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Multipurpose gym featuring extensive fitness facilities and a relaxing Nordic Spa.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-a1e7-76df-ad2a-bb676876d63a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-a1e7-76df-ad2a-bb676876d63a",
        "storage_key": "property/6767906449167165/019d021e-a1e7-76df-ad2a-bb676876d63a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-taceast-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=13441179354482565633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-east-gym--pool",
      "poi_latitude": "61.181272",
      "poi_longitude": "-149.7830598",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-337-9550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-954b19ef1172",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-8ujJiCXyFYRAWI_kmipiLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1caa3247-f394-4a98-9622-2916c068db62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3101 Penland Pkwy, Anchorage, AK 99508, USA",
      "poi_short_description": "Welcoming gym featuring high-quality exercise equipment and tanning facilities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021f-3467-700d-af3e-1f626ff47694.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-3467-700d-af3e-1f626ff47694",
        "storage_key": "property/6767906449167165/019d021f-3467-700d-af3e-1f626ff47694.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/anchorage-northway-ak?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=18184237711396403856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "61.21684",
      "poi_longitude": "-149.81975",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-868-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccce-708f-882a-214184819b48",
        "storage_key": "property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE12XiUKWyFYRkHoLs9pjW_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_61c2a6e2-28bc-4b9f-b688-3748b7bec6a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Anchorage Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "701 W 36th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "Welcoming yoga studio offering a variety of classes and hot yoga sessions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddd-8a69-719a-8a82-a8e8ee720b50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddd-8a69-719a-8a82-a8e8ee720b50",
        "storage_key": "property/6767906449167165/01a10ddd-8a69-719a-8a82-a8e8ee720b50.webp",
        "width": 852,
        "height": 1280
      },
      "poi_business_url": "http://anchorageyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1189873777368163935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-yoga",
      "poi_latitude": "61.18870920000001",
      "poi_longitude": "-149.8964094",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-562-9642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccce-708f-882a-214184819b48",
        "storage_key": "property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ90egSsKXyFYRX-aUc-VHgxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_fb13277b-fd56-4e37-b477-2fc0679f6f07",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Chanshtnu Muldoon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1301 Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Community park featuring modern play equipment and seasonal offerings like a farmers market and ice skating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-a340-70a3-a3b5-51477c61cd2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-a340-70a3-a3b5-51477c61cd2a",
        "storage_key": "property/6767906449167165/01a10ddf-a340-70a3-a3b5-51477c61cd2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://muldoonfarmersmarket.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=446543973844265851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chanshtnu-muldoon-park",
      "poi_latitude": "61.208991",
      "poi_longitude": "-149.731189",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-cb02-76eb-bb4f-3f79a0d63faf",
        "storage_key": "property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFz9TVbuWyFYReyuU2WBxMgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8e9e541d-6c7c-4dda-8972-36e68c2f4402",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Chanshtnu Muldoon Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8231 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-a283-7279-8d17-dee29d030939.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-a283-7279-8d17-dee29d030939",
        "storage_key": "property/6767906449167165/01a10ddf-a283-7279-8d17-dee29d030939.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/DogParks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16175054650657742652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chanshtnu-muldoon-dog-park",
      "poi_latitude": "61.20869949999999",
      "poi_longitude": "-149.7280893",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-343-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-cb02-76eb-bb4f-3f79a0d63faf",
        "storage_key": "property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv4mk_KSWyFYRPB_8coFWeeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_9938f733-ac5a-461e-823e-bb84dbc34a0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Russian Jack Springs Park South",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 Lidia Selkregg Ln, Anchorage, AK 99508, USA",
      "poi_short_description": "Year-round, well-maintained park with cross-country trails and groomed hills for sledding, plus golf.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-9fe0-763d-ad88-4e731219842d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-9fe0-763d-ad88-4e731219842d",
        "storage_key": "property/6767906449167165/01a10ddf-9fe0-763d-ad88-4e731219842d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10203965088416518130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russian-jack-springs-park-south",
      "poi_latitude": "61.2061283",
      "poi_longitude": "-149.7887878",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-cb02-76eb-bb4f-3f79a0d63faf",
        "storage_key": "property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJawU6nPSWyFYR8s-NWy_Em40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_be1bb4dd-a57a-4b4f-8fc4-d3421f79d5e0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Nunaka Valley Park North",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6321 Mink Ave, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-a642-732e-b3c0-2ca3bbef74e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-a642-732e-b3c0-2ca3bbef74e7",
        "storage_key": "property/6767906449167165/01a10ddf-a642-732e-b3c0-2ca3bbef74e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14252792633980944639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nunaka-valley-park-north",
      "poi_latitude": "61.2087704",
      "poi_longitude": "-149.7646277",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-cb02-76eb-bb4f-3f79a0d63faf",
        "storage_key": "property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0bapTJKWyFYR_wC91WIXzMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_7303b0fe-9bba-4492-a9e5-e6ce8102d626",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Cheney Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2245 Baxter Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Peaceful city park featuring scenic walking trails and lake fishing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-a3f6-7268-98bd-1ae4eb708a05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-a3f6-7268-98bd-1ae4eb708a05",
        "storage_key": "property/6767906449167165/01a10ddf-a3f6-7268-98bd-1ae4eb708a05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1659871588540635741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheney-lake-park",
      "poi_latitude": "61.200136",
      "poi_longitude": "-149.7630764",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-cb02-76eb-bb4f-3f79a0d63faf",
        "storage_key": "property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJza3J7-qWyFYRXVq6V2oMCRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_0480caa0-34b0-44cc-a448-5f9c04ca3b33",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Ira Walker Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5850 E 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-a6b7-74b0-bfdc-3551d9ee2981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-a6b7-74b0-bfdc-3551d9ee2981",
        "storage_key": "property/6767906449167165/01a10ddf-a6b7-74b0-bfdc-3551d9ee2981.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16062301420693632120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ira-walker-park",
      "poi_latitude": "61.21680259999999",
      "poi_longitude": "-149.7715387",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-cb02-76eb-bb4f-3f79a0d63faf",
        "storage_key": "property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-Y4HI-WyFYReDSyVwrC6N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_010b0567-0cbc-496d-adf4-c6f8cf3b1b43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Roosevelt Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2200 Jefferson Ave, Anchorage, AK 99517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-a215-717e-8625-f3d6c67d7ffb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-a215-717e-8625-f3d6c67d7ffb",
        "storage_key": "property/6767906449167165/01a10ddf-a215-717e-8625-f3d6c67d7ffb.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17583260538816129394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roosevelt-park",
      "poi_latitude": "61.1822014",
      "poi_longitude": "-149.9217121",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-cb02-76eb-bb4f-3f79a0d63faf",
        "storage_key": "property/6767906449167165/019d021e-cb02-76eb-bb4f-3f79a0d63faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD7WPUeSXyFYRcmlHyUxKBPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ca01956a-861e-4706-9ed3-1062f35b862e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "DeBarr & Muldoon WNW",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-a213-73e7-9d96-2476b4bfc849.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-a213-73e7-9d96-2476b4bfc849",
        "storage_key": "property/6767906449167165/01a10ddf-a213-73e7-9d96-2476b4bfc849.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1706341293805001123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "debarr--muldoon-wnw",
      "poi_latitude": "61.2098749",
      "poi_longitude": "-149.7351285",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-b77b-723e-8611-306580fc4a09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10ddf-b77b-723e-8611-306580fc4a09",
        "storage_key": "property/6767906449167165/01a10ddf-b77b-723e-8611-306580fc4a09.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3iS0ryWyFYRo9nTul0krhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_61adeb77-d523-4df7-b45e-4d7b3e9efa32",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "DeBarr & Creekside Ctr Ene",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3805994061113187390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "debarr--creekside-ctr-ene",
      "poi_latitude": "61.20982599999999",
      "poi_longitude": "-149.740443",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-b77b-723e-8611-306580fc4a09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10ddf-b77b-723e-8611-306580fc4a09",
        "storage_key": "property/6767906449167165/01a10ddf-b77b-723e-8611-306580fc4a09.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxqlQb2WyFYRPtzl_W6b0TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_c751b617-6abf-480c-ac04-cabb765c283a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "People Mover",
      "poi_type": "Transportation & Transit",
      "poi_address": "3600 Doctor M.L.K. Jr Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-a4ce-7229-b65e-5cba0a2c0339.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-a4ce-7229-b65e-5cba0a2c0339",
        "storage_key": "property/6767906449167165/01a10ddf-a4ce-7229-b65e-5cba0a2c0339.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14529945198539884947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "people-mover",
      "poi_latitude": "61.17707559999999",
      "poi_longitude": "-149.8139324",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-343-8402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccce-708f-882a-214184819b48",
        "storage_key": "property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzSp6ChCXyFYRk8nc1Cy8pMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_b8b25d4a-7fbb-4b11-bf0c-e70a97cb62e0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Downtown Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "618 H St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-aaa4-70ce-81a4-0a2aa9930f22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-aaa4-70ce-81a4-0a2aa9930f22",
        "storage_key": "property/6767906449167165/01a10ddf-aaa4-70ce-81a4-0a2aa9930f22.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.valleytransitak.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1822634443753356636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center",
      "poi_latitude": "61.21611670000001",
      "poi_longitude": "-149.8977308",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-892-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-b77b-723e-8611-2f396812ea01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10ddf-b77b-723e-8611-2f396812ea01",
        "storage_key": "property/6767906449167165/01a10ddf-b77b-723e-8611-2f396812ea01.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__g5wIC9yFYRXH1Pr15MSxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_cd0333ca-213f-4fa7-8e54-3601cb7ee397",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Dimond Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-ac83-7419-ae03-6d57f876feeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-ac83-7419-ae03-6d57f876feeb",
        "storage_key": "property/6767906449167165/01a10ddf-ac83-7419-ae03-6d57f876feeb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211653549311854446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-transit-center",
      "poi_latitude": "61.142764",
      "poi_longitude": "-149.871953",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-b77b-723e-8611-306580fc4a09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10ddf-b77b-723e-8611-306580fc4a09",
        "storage_key": "property/6767906449167165/01a10ddf-b77b-723e-8611-306580fc4a09.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVAwvdGZyFYRbgfTO7YT3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_2166d924-2d27-4f1e-b85f-5eae0b3e3a43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-ad02-7466-950d-0c2321e6d5e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-ad02-7466-950d-0c2321e6d5e8",
        "storage_key": "property/6767906449167165/01a10ddf-ad02-7466-950d-0c2321e6d5e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-d310-717c-8880-7f1ca8dd32af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-d310-717c-8880-7f1ca8dd32af",
        "storage_key": "property/6767906449167165/019d021e-d310-717c-8880-7f1ca8dd32af.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_9ce554b1-420c-43c5-bd25-bed1744c194a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Eagle River Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99577, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-af51-704f-9526-165765694bce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-af51-704f-9526-165765694bce",
        "storage_key": "property/6767906449167165/01a10ddf-af51-704f-9526-165765694bce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5293723384036886587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eagle-river-transit-center",
      "poi_latitude": "61.32776500000001",
      "poi_longitude": "-149.573677",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-b77b-723e-8611-306580fc4a09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10ddf-b77b-723e-8611-306580fc4a09",
        "storage_key": "property/6767906449167165/01a10ddf-b77b-723e-8611-306580fc4a09.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJb--R-XLryFYRO4iy1F4Vd0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_587f5ad6-b9f5-4d94-850e-a6ff71466bc3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Anchorage VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-ace8-768c-8bef-41f3e1ea2936.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-ace8-768c-8bef-41f3e1ea2936",
        "storage_key": "property/6767906449167165/01a10ddf-ace8-768c-8bef-41f3e1ea2936.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaska.va.gov/locations/directions.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1810043390262328329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-va-medical-center",
      "poi_latitude": "61.23270319999999",
      "poi_longitude": "-149.7444828",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 888-353-7574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-d2c2-73c0-88f2-71531382be54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-d2c2-73c0-88f2-71531382be54",
        "storage_key": "property/6767906449167165/019d021e-d2c2-73c0-88f2-71531382be54.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJRYzvJi-UyFYRCTyhmN-QHhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0d4704c7-2d09-4d32-8b64-fd6692528c1f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Alaska Native Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-bae9-727a-bccb-79e2e313e01e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-bae9-727a-bccb-79e2e313e01e",
        "storage_key": "property/6767906449167165/019d021e-bae9-727a-bccb-79e2e313e01e.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://anmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633987291157363904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-medical-center",
      "poi_latitude": "61.182452",
      "poi_longitude": "-149.8002427",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-563-2662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-d2c2-73c0-88f2-71531382be54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-d2c2-73c0-88f2-71531382be54",
        "storage_key": "property/6767906449167165/019d021e-d2c2-73c0-88f2-71531382be54.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_bUZRyXyFYRwPw76oDwVK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b2e32ef5-399b-4d0d-9997-4ea032e3692c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Southcentral Foundation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4320 Diplomacy Dr #2300, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.southcentralfoundation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3019730341503088136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southcentral-foundation",
      "poi_latitude": "61.1816621",
      "poi_longitude": "-149.7999688",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-729-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccce-708f-882a-214184819b48",
        "storage_key": "property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTcpchyXyFYRCLbCEr886Ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_8ec40b2a-6ee4-4869-a3cd-e4e6423fbcc0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Alaska Native Tribal Health Consortium",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Ambassador Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-ac8a-7127-8dd4-096c8baf42a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-ac8a-7127-8dd4-096c8baf42a7",
        "storage_key": "property/6767906449167165/01a10ddf-ac8a-7127-8dd4-096c8baf42a7.webp",
        "width": 1280,
        "height": 301
      },
      "poi_business_url": "http://www.anthc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002423738872135572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-tribal-health-consortium",
      "poi_latitude": "61.18400399999999",
      "poi_longitude": "-149.7994651",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-729-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-d2c2-73c0-88f2-71531382be54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-d2c2-73c0-88f2-71531382be54",
        "storage_key": "property/6767906449167165/019d021e-d2c2-73c0-88f2-71531382be54.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7c0qhyXyFYRlH_kVRRT6Q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_75a342d5-a3e5-4d33-9160-56358d23da02",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "University of Alaska Anchorage",
      "poi_type": "Education",
      "poi_address": "3211 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-872d-7158-825b-a442191b1a68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-872d-7158-825b-a442191b1a68",
        "storage_key": "property/6767906449167165/019d021e-872d-7158-825b-a442191b1a68.webp",
        "width": 672,
        "height": 400
      },
      "poi_business_url": "https://www.uaa.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963319407001083725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-anchorage",
      "poi_latitude": "61.1910421",
      "poi_longitude": "-149.8195598",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-786-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-c6cb-72e5-b244-954b19ef1172",
        "storage_key": "property/6767906449167165/019d021e-c6cb-72e5-b244-954b19ef1172.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8bmy6gCXyFYRTR9S4kzTHyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0344d1af-8ad0-4bba-ad1d-833d4b968789",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "Aurora Military Housing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6350 Arctic Warrior Dr, Anchorage, AK 99506, USA",
      "poi_short_description": "On-base property management company offering residential housing and maintenance services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-afca-766c-88fd-4ef5fc44277c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-afca-766c-88fd-4ef5fc44277c",
        "storage_key": "property/6767906449167165/01a10ddf-afca-766c-88fd-4ef5fc44277c.webp",
        "width": 1280,
        "height": 512
      },
      "poi_business_url": "http://www.auroramilitaryhousing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16357749582599971693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aurora-military-housing",
      "poi_latitude": "61.23655890000001",
      "poi_longitude": "-149.8271824",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-753-1023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccce-708f-882a-214184819b48",
        "storage_key": "property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzrFog6WyFYRbWOqC5RmAuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_ca1bb2a7-fc2b-4cf9-90ee-6489e6fef02e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "custom",
      "poi_name": "ConocoPhillips Alaska",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 G St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/01a10ddf-b25f-704c-8c67-dd89200e997f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10ddf-b25f-704c-8c67-dd89200e997f",
        "storage_key": "property/6767906449167165/01a10ddf-b25f-704c-8c67-dd89200e997f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://alaska.conocophillips.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18204751589556885795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conocophillips-alaska",
      "poi_latitude": "61.215194",
      "poi_longitude": "-149.8962402",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-276-1215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021e-ccce-708f-882a-214184819b48",
        "storage_key": "property/6767906449167165/019d021e-ccce-708f-882a-214184819b48.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9x13m4C9yFYRIxnEJx5FpPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_de12a6bb7816d95b91dd7681",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_11dcdc6081ac3f67109bfa2b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_51d4aa1c81c50f2d79a80e35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7122711391937d1f729e6e6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_8e394c76025768ab5ef25186",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_c4e78fec9c5cad071a8f04e8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "rating": "5",
      "name": "Kalkidan Bulbula",
      "text": "Cody, the maintenance man, IS AMAZING! We have lived here for about 4 months now and any issue we have he is the here ready to work. He is kind to our animals and always communicative about when he is coming to the apartment. He is super knowledgeable and even gives tips to make things easier for the future. We just moved to Admirals Cove but Cody has made us happy to be here!!",
      "date": "2025-06-04",
      "title": "false"
    },
    {
      "id": "ec_65aa5986e3b7f8d6046689a1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "rating": "5",
      "name": "Sean Worrell",
      "text": "So.... I only spent the week here helping my son move in, but I love this Apt. It's has a beautiful layout and is perfect for what he needs. I also got to keep up with my cardio as they have a \"fitness room.\"",
      "date": "2022-02-04",
      "title": "false"
    },
    {
      "id": "ec_88bad64c35231891a9454141",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "rating": "5",
      "name": "David Boudreaux",
      "text": "Christopher came out with in 5 mins of an emergency maintenance situation over the weekend and took care of us in a timely manner. Went above and beyond for the wife and I and we greatly appreciate it. Ty sir where ever you are.",
      "date": "2025-08-02",
      "title": "false"
    },
    {
      "id": "ec_fa2196800651691309c4d5e4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "rating": "5",
      "name": "Sandi Ah Sue",
      "text": "Cody did a great job fixing my toilet issues!  He worked extended hours on two different days to help solve my problem. Thank you for the extra effort!  Your hard work and kindness is appreciated!",
      "date": "2025-05-07",
      "title": "false"
    },
    {
      "id": "ec_a43541c4f84b2107fe1c4e78",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "rating": "5",
      "name": "Gerry Keffer",
      "text": "We'd been having problems with a toilet not completely flushing. Cody was sent to diagnose the problem, which he did expediently. He came back today to replace the broken part. He was very courteous and polite throughout his time here with us. Thank you for sending Cody to fix our problem...",
      "date": "2025-06-06",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_1d05289a6c70a8c056d06ae8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019ddd00-c284-7550-a510-5dd503739465.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddd00-c284-7550-a510-5dd503739465",
        "storage_key": "property/6767906449167165/019ddd00-c284-7550-a510-5dd503739465.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2x2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ATd3sXjGHjM"
    },
    {
      "id": "ec_dfec200c9ed6723a0b5f23c2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167165/019ddd00-c2a6-7528-bc16-2e0ce36dc92b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddd00-c2a6-7528-bc16-2e0ce36dc92b",
        "storage_key": "property/6767906449167165/019ddd00-c2a6-7528-bc16-2e0ce36dc92b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2x2 Furnished",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=w4mi49LwxQ1"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-d0b2-70ac-8c77-b5a57ac16639",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Admirals Cove Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "generator",
      "page_item_url": "in-unit-washer-dryer-apartments-anchorage",
      "search_query": "apartments with in-unit washer dryer in Anchorage",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer Dryer",
      "h2_subtitle": "Discover Admirals Cove offers Anchorage apartments with in-unit washer dryer. Enjoy the convenience of modern living in Northeast Anchorage.",
      "page_copy": "Welcome to Admirals Cove, where comfort meets convenience in Anchorage. Our apartments with in-unit washer dryer cater to your lifestyle, ensuring that laundry day is as smooth as possible. Located in the vibrant Northeast Anchorage neighborhood, our community proudly boasts top-tier features like stainless steel appliances and a patio or balcony for each unit. \n\nAt Admirals Cove, residents enjoy the relaxed atmosphere while taking advantage of on-site amenities such as the state-of-the-art fitness center and dog park. The inclusion of an in-unit washer dryer means more time enjoying these great features. Experience the blend of convenience and modern living at Admirals Cove today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Washer Dryer",
      "seo_description": "Explore Admirals Cove in Anchorage for apartments with in-unit washer dryer in Northeast Anchorage. Enjoy modern living and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-park-anchorage",
      "search_query": "dog-friendly apartments with park in Anchorage Municipality",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with Park",
      "h2_subtitle": "Discover dog-friendly living at Admirals Cove in Anchorage Municipality. Enjoy a dedicated dog park and pet-friendly community.",
      "page_copy": "At Admirals Cove, we understand that pets are family. That's why we offer dog-friendly apartments with a dedicated on-site park in Anchorage Municipality. Living in our community means having an easily accessible space for your furry friends to run and play, all within the safety and comfort of home.\n\nLocated in Northeast Anchorage, Admirals Cove provides a perfect blend of urban convenience and natural beauty. Alongside our pet-friendly amenities, residents enjoy features such as balconies, stainless steel appliances, and a cutting-edge fitness center. Embrace a lifestyle where every family member, including four-legged ones, feels at home and welcome.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments with Park",
      "seo_description": "Find dog-friendly apartments with a park at Admirals Cove in Anchorage Municipality. Perfect for pet lovers seeking convenience and care.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-northeast-anchorage",
      "search_query": "state-of-the-art fitness center apartments Northeast Anchorage",
      "category": "Amenity",
      "h1_title": "State-of-the-Art Fitness Center Apartments",
      "h2_subtitle": "Experience living at Admirals Cove in Northeast Anchorage, where every resident has access to a state-of-the-art fitness center and more.",
      "page_copy": "Admirals Cove offers a premier living experience in Northeast Anchorage, featuring apartments equipped with a state-of-the-art fitness center. Our community values active lifestyles, providing residents with high-quality cardio machines and exercise equipment right at their doorstep. \n\nLocated in the heart of Northeast Anchorage, Admirals Cove combines modern amenities with a convenient urban setting. Besides the top-tier fitness center, residents can enjoy stainless steel appliances, a private patio or balcony, and pet-friendly spaces including an on-site dog park. Discover the ultimate blend of health-focused facilities and modern comfort at Admirals Cove.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "State-of-the-Art Fitness Center Apartments",
      "seo_description": "Live at Admirals Cove in Northeast Anchorage with access to a state-of-the-art fitness center and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "generator",
      "page_item_url": "luxury-apartments-granite-countertops-anchorage",
      "search_query": "luxury apartments with granite countertops Anchorage AK",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Granite Countertops",
      "h2_subtitle": "Discover luxury living at Admirals Cove in Anchorage, AK, featuring upscale apartments with stunning granite countertops and premium amenities.",
      "page_copy": "At Admirals Cove, we redefine luxury living in Anchorage, AK with thoughtfully designed apartments featuring elegant granite countertops. These luxurious finishes enhance the aesthetic and functionality of your kitchen, creating a refined living experience in our vibrant community.\n\nBeyond the granite countertops, Admirals Cove offers a wealth of amenities designed to elevate your lifestyle. Enjoy the comfort of stainless steel appliances, the convenience of in-unit washer dryers, and recreational perks like a state-of-the-art fitness center and an on-site dog park. Located in Northeast Anchorage, you’ll find a perfect balance of luxury and convenience, setting a new standard for upscale living in Anchorage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Granite Countertops",
      "seo_description": "Explore luxury apartments with granite countertops at Admirals Cove in Anchorage, AK. Experience premium amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "generator",
      "page_item_url": "modern-apartments-stainless-steel-99504",
      "search_query": "modern apartments with stainless steel appliances 99504",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Discover modern living at Admirals Cove, located in the 99504 zip code, featuring apartments with stylish stainless steel appliances.",
      "page_copy": "Admirals Cove offers modern apartments in the 99504 area of Anchorage that are thoughtfully designed to include sleek stainless steel appliances. Elevate your cooking experience with these high-quality features while enjoying the contemporary design and functionality they bring to your home.\n\nSituated in Northeast Anchorage, our community provides an array of other amenities, such as a state-of-the-art fitness center and an on-site dog park, enhancing your lifestyle and leisure. Each apartment also includes a private patio or balcony, enabling you to enjoy the beauty of your surroundings. Live in style and comfort at Admirals Cove, where modern convenience meets exceptional living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Stainless Steel Appliances",
      "seo_description": "Explore modern apartments with stainless steel appliances at Admirals Cove in Anchorage's 99504 zip code. Experience comfort and style.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-northeast-anchorage",
      "search_query": "two bedroom apartments northeast anchorage",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Northeast Anchorage",
      "h2_subtitle": "Explore spacious two-bedroom apartments at Admirals Cove, perfectly situated in the vibrant Northeast Anchorage neighborhood.",
      "page_copy": "Admirals Cove proudly offers spacious two-bedroom apartments in Northeast Anchorage, tailored to meet the needs of diverse lifestyles. Our community is ideal for families, roommates, or individuals seeking extra space. Each apartment is designed with modern conveniences, ensuring a comfortable living experience.\n\nLocated amidst the natural beauty of Northeast Anchorage, Admirals Cove places residents near everything they need. Enjoy the luxury of stainless steel appliances, a private patio or balcony, and amenities like a state-of-the-art fitness center and on-site dog park. Discover the ideal balance of comfort and convenience with our two-bedroom offerings.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Northeast Anchorage",
      "seo_description": "Discover spacious two-bedroom apartments at Admirals Cove in Northeast Anchorage. Enjoy modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-alaska-northeast-anchorage",
      "search_query": "apartments near university of alaska anchorage northeast anchorage",
      "category": "School",
      "h1_title": "Apartments Near University of Alaska Anchorage",
      "h2_subtitle": "Conveniently located in Northeast Anchorage, Admirals Cove offers ideal apartment living close to the University of Alaska Anchorage.",
      "page_copy": "Find your perfect home at Admirals Cove, where proximity to the University of Alaska Anchorage makes it an excellent choice for students and faculty alike. Nestled in the energetic Northeast Anchorage community, our apartments offer quick and easy access to campus life alongside the peaceful retreat of a residential setting.\n\nBeyond our prime location, Admirals Cove provides residents with modern amenities, such as stainless steel appliances and private patios or balconies. Engage in fitness routines at our state-of-the-art fitness center or enjoy leisure time at the on-site dog park. Experience a blend of academia and comfort, balancing education with recreation seamlessly at our Anchorage apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Alaska Anchorage",
      "seo_description": "Live close to the University of Alaska in Northeast Anchorage at Admirals Cove. Experience ideal living with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-native-medical-center",
      "search_query": "apartments near Alaska Native Medical Center Anchorage",
      "category": "Hospital",
      "h1_title": "Apartments Near Alaska Native Medical Center",
      "h2_subtitle": "Admirals Cove offers convenient living close to the Alaska Native Medical Center in Anchorage, with easy access to work and leisure.",
      "page_copy": "Admirals Cove provides an ideal home for those looking for apartments near the Alaska Native Medical Center in Anchorage. Perfectly located, our community offers quick commutes for healthcare professionals and families seeking proximity to this vital facility.\n\nBeyond our strategic location, Admirals Cove enhances everyday living with modern amenities like stainless steel appliances, private patios or balconies, and a state-of-the-art fitness center. Our on-site dog park invites residents to relax and enjoy a vibrant community atmosphere. Experience comfort, convenience, and connectivity at Admirals Cove, where your well-being aligns with your lifestyle needs in Anchorage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Native Medical Center",
      "seo_description": "Discover Admirals Cove for convenient living near the Alaska Native Medical Center, Anchorage. Enjoy modern amenities and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "generator",
      "page_item_url": "apartments-close-to-providence-medical-center",
      "search_query": "apartments close to Providence Alaska Medical Center Northeast Anchorage",
      "category": "Hospital",
      "h1_title": "Apartments Close to Providence Alaska Medical Center",
      "h2_subtitle": "Reside at Admirals Cove, conveniently close to Providence Alaska Medical Center in Northeast Anchorage, where comfort meets accessibility.",
      "page_copy": "Discover exceptional apartment living at Admirals Cove, positioned conveniently close to Providence Alaska Medical Center in Northeast Anchorage. Ideal for medical professionals or families seeking easy access to healthcare services, our community ensures a hassle-free commute.\n\nIn addition to our prime location, Admirals Cove offers an array of amenities designed to enhance your lifestyle. Enjoy the benefits of stainless steel appliances, a private patio or balcony, and an on-site state-of-the-art fitness center. Our community also features a dog park, catering to pet owners and promoting an active, social living environment. Choose Admirals Cove for a balanced lifestyle in Northeast Anchorage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Providence Alaska Medical Center",
      "seo_description": "Live near Providence Medical Center in Northeast Anchorage at Admirals Cove. Modern amenities and convenient location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-botanical-garden-northeast",
      "search_query": "apartments near alaska botanical garden northeast anchorage",
      "category": "Park",
      "h1_title": "Apartments Near Alaska Botanical Garden",
      "h2_subtitle": "Admirals Cove offers serene living near the Alaska Botanical Garden in Northeast Anchorage, perfect for nature and garden enthusiasts.",
      "page_copy": "Immerse yourself in natural beauty at Admirals Cove, located near the enchanting Alaska Botanical Garden in Northeast Anchorage. These apartments are an excellent choice for those who relish being close to lush landscapes and tranquil pathways. \n\nAt Admirals Cove, residents enjoy modern conveniences like stainless steel appliances, private patios or balconies, and a state-of-the-art fitness center, seamlessly melding nature with contemporary living. An onsite dog park is perfect for enjoying outdoor time with your furry friends. Experience a harmonious blend of serene garden proximity and vibrant community living at Admirals Cove.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Botanical Garden",
      "seo_description": "Discover Admirals Cove near the Alaska Botanical Garden, Northeast Anchorage. Enjoy serene living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167165",
      "source": "generator",
      "page_item_url": "apartments-close-to-delaney-park",
      "search_query": "apartments close to delaney park anchorage municipality",
      "category": "Park",
      "h1_title": "Apartments Close to Delaney Park",
      "h2_subtitle": "Experience vibrant living at Admirals Cove, close to Delaney Park within the Anchorage Municipality, offering both relaxation and urban amenities.",
      "page_copy": "Admirals Cove promises an exceptional living experience close to Delaney Park within the Anchorage Municipality. Perfectly situated for those who appreciate urban green spaces, our community offers easy access to recreational opportunities at Delaney Park.\n\nResidents at Admirals Cove benefit from a variety of modern amenities including state-of-the-art stainless steel appliances, spacious patios or balconies, and a comprehensive fitness center. Pet owners will be pleased with our on-site dog park, fostering an inviting and active community environment. Choose Admirals Cove for its strategic location, just moments away from the vibrant settings of Delaney Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Delaney Park",
      "seo_description": "Live near Delaney Park in Anchorage Municipality at Admirals Cove. Enjoy modern living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309342602"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073082944"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/ceea19b0-7733-4a5c-86da-10882c9ba871/app.js?property=ceea19b0-7733-4a5c-86da-10882c9ba871&propertyName=Admirals+Cove&channelUuid=c248fb75-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47571307064"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkpJSC9jQmUxZk1vQTF2OEY0VTdoUmc9PSIsInZhbHVlIjoiV2RqR2VMMmI1b1Y2NVFSQXZ1MmYrQT09IiwibWFjIjoiZDIxNjE5OWQwOGZjZGE0OThiNjM3M2E0M2YyZTE4ZTJhOTU5MjRmMjNhMzg0NTE1M2UzZTUzYTM2NzQ1YWYyNCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309342602",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073082944",
  "custom_rollout_phase": "Phase 8",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/ceea19b0-7733-4a5c-86da-10882c9ba871/app.js?property=ceea19b0-7733-4a5c-86da-10882c9ba871&propertyName=Admirals+Cove&channelUuid=c248fb75-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47571307064",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkpJSC9jQmUxZk1vQTF2OEY0VTdoUmc9PSIsInZhbHVlIjoiV2RqR2VMMmI1b1Y2NVFSQXZ1MmYrQT09IiwibWFjIjoiZDIxNjE5OWQwOGZjZGE0OThiNjM3M2E0M2YyZTE4ZTJhOTU5MjRmMjNhMzg0NTE1M2UzZTUzYTM2NzQ1YWYyNCJ9",
  "custom_audioeye_site_id": "cf58c6aa-4af0-4b29-8a62-d57f16769ef6",
  "custom_audioeye_site_hash": "3dbb9e7b73ff61962ab404eef86fd622"
};

export const generatedAt = '2026-11-02T18:12:24.193Z';
